/*-------- KC SHARED MEDIA LIGHTBOX --------
   One media lightbox shared by the news video strip (.kc-tour-videos__item), the
   music-timeline "Watch & See" panel, and the album-detail media gallery. Built
   once on first open, then reused. Look + behavior come from the old news video
   lightbox: full-bleed dark overlay, orange circular arrows (reuses the
   .kc-lightbox__nav / __close styles), counter, caption, Esc + arrow keys, inline
   YouTube and inline <video>. Tabs (All/Videos/Photos), a "see all" CTA, and an
   accent colour are opt-in per caller.

   KCMediaLightbox.open(items, startIndex, opts)
     items: [{ kind:'v'|'p', label, src, thumb, ytid?, cat? }]
     opts:  { title?, accent?, tabs?, captionType?, caption?, seeAll?:{href,label} }
            caption:false hides the per-item caption entirely. */
window.KCMediaLightbox = (function () {
  'use strict';

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function cssUrl(u) { return "url('" + String(u == null ? '' : u).replace(/'/g, "\\'") + "')"; }
  function ytId(u) {
    if (!u) return null;
    u = String(u);
    if (/^[\w-]{11}$/.test(u)) return u;
    var m = u.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([\w-]{11})/);
    return m ? m[1] : null;
  }
  function isFileVideo(u) { return /\.(mp4|webm|ogg|ogv|mov|m4v)(\?|#|$)/i.test(u || ''); }

  // Same arrow icon (icon-arrow.svg, /collections carousel) used across all KC lightboxes; navy via .kc-lightbox__nav.
  var CARET = '<svg class="kc-lightbox__caret" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" width="56" height="56" aria-hidden="true"><circle cx="12" cy="12" r="11" fill="rgba(0,0,0,0.55)"/><path d="M10 8.5l6 3.5-6 3.5z" fill="#fff"/></svg>';

  var box, frame, capEl, countEl, tabsEl, seeEl, titleEl, prevBtn, nextBtn;
  var all = [], list = [], idx = 0, tab = 'all';
  var showTabs = false, accent = '', captionType = true, showCaption = true;
  var lastFocus = null;

  function build() {
    box = document.createElement('div');
    box.className = 'kc-media-lightbox';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML =
      '<button class="kc-lightbox__close" type="button" aria-label="Close">×</button>' +
      '<button class="kc-lightbox__nav kc-lightbox__nav--prev" type="button" aria-label="Previous">' + CARET + '</button>' +
      '<button class="kc-lightbox__nav kc-lightbox__nav--next" type="button" aria-label="Next">' + CARET + '</button>' +
      '<div class="kc-media-lightbox__inner">' +
        '<div class="kc-media-lightbox__bar">' +
          '<span class="kc-media-lightbox__title" data-kcml-title hidden></span>' +
          '<div class="kc-media-lightbox__tabs" data-kcml-tabs hidden></div>' +
        '</div>' +
        '<figure class="kc-media-lightbox__stage">' +
          '<div class="kc-media-lightbox__frame" data-kcml-frame></div>' +
          '<figcaption class="kc-media-lightbox__cap" data-kcml-cap></figcaption>' +
        '</figure>' +
        '<div class="kc-media-lightbox__foot">' +
          '<span class="kc-media-lightbox__count" data-kcml-count></span>' +
          '<a class="kc-media-lightbox__see" data-kcml-see hidden></a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(box);
    frame = box.querySelector('[data-kcml-frame]');
    capEl = box.querySelector('[data-kcml-cap]');
    countEl = box.querySelector('[data-kcml-count]');
    tabsEl = box.querySelector('[data-kcml-tabs]');
    seeEl = box.querySelector('[data-kcml-see]');
    titleEl = box.querySelector('[data-kcml-title]');
    prevBtn = box.querySelector('.kc-lightbox__nav--prev');
    nextBtn = box.querySelector('.kc-lightbox__nav--next');

    box.querySelector('.kc-lightbox__close').addEventListener('click', close);
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    box.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-kcml-tab]');
      if (t) { tab = t.getAttribute('data-kcml-tab'); applyTab(0); return; }
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!box || box.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'Tab') {
        var f = box.querySelectorAll('a[href], button:not([disabled]), iframe, video[controls], [tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function filtered() { return tab === 'all' ? all.slice() : all.filter(function (m) { return m.kind === tab; }); }

  function renderTabs() {
    if (!showTabs) { tabsEl.hidden = true; tabsEl.innerHTML = ''; return; }
    var nv = 0, np = 0;
    all.forEach(function (m) { if (m.kind === 'v') nv++; else np++; });
    if (nv > 0 && np > 0) {
      tabsEl.hidden = false;
      var defs = [['all', 'All', nv + np], ['v', 'Videos', nv], ['p', 'Photos', np]];
      tabsEl.innerHTML = defs.map(function (d) {
        return '<button class="kc-media-lightbox__tab' + (tab === d[0] ? ' is-on' : '') + '" type="button" data-kcml-tab="' + d[0] + '">' + esc(d[1]) + ' (' + d[2] + ')</button>';
      }).join('');
    } else { tabsEl.hidden = true; tabsEl.innerHTML = ''; }
  }

  function render() {
    var it = list[idx];
    if (!it) return;
    frame.className = 'kc-media-lightbox__frame';
    frame.style.backgroundImage = '';
    frame.style.backgroundColor = '';
    if (it.kind === 'p') {
      frame.classList.add('is-photo');
      if (accent) frame.style.backgroundColor = accent;
      frame.innerHTML = '<img class="kc-media-lightbox__img" src="' + escAttr(it.src || it.thumb) + '" alt="' + escAttr(it.label || '') + '">';
    } else {
      var yt = it.ytid || ytId(it.src);
      if (yt) {
        frame.classList.add('is-video');
        frame.innerHTML = '<iframe class="kc-media-lightbox__iframe" src="https://www.youtube.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0&playsinline=1" title="' + escAttr(it.label || '') + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
      } else if (isFileVideo(it.src)) {
        frame.classList.add('is-video');
        frame.innerHTML = '<video class="kc-media-lightbox__video" src="' + escAttr(it.src) + '" controls autoplay playsinline preload="metadata"></video>';
      } else {
        frame.classList.add('is-photo');
        if (it.thumb) frame.style.backgroundImage = cssUrl(it.thumb);
        frame.innerHTML = it.src
          ? '<a class="kc-media-lightbox__playout" href="' + escAttr(it.src) + '" target="_blank" rel="noopener" aria-label="Play video">' + ICON_PLAY + '</a>'
          : '';
      }
    }
    var bits = [];
    if (it.label) bits.push(it.label);
    if (it.cat) bits.push(it.cat);
    if (captionType) bits.push(it.kind === 'v' ? 'video' : 'photo');
    capEl.textContent = bits.join('  ·  ');
    capEl.hidden = !showCaption || !bits.length;
    countEl.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    var single = list.length <= 1;
    prevBtn.style.display = single ? 'none' : '';
    nextBtn.style.display = single ? 'none' : '';
  }

  function applyTab(start) {
    list = filtered();
    if (!list.length) { tab = 'all'; list = all.slice(); }
    idx = Math.max(0, Math.min(list.length - 1, start || 0));
    renderTabs();
    render();
  }

  function go(d) { if (list.length) { idx = (idx + d + list.length) % list.length; render(); } }

  function close() {
    if (!box) return;
    box.hidden = true;
    frame.innerHTML = '';            // clearing the iframe/video stops playback
    document.body.classList.remove('kc-lightbox-open');
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  function open(items, start, opts) {
    if (!items || !items.length) return;
    if (!box) build();
    lastFocus = document.activeElement;
    opts = opts || {};
    all = items.slice();
    showTabs = !!opts.tabs;
    accent = opts.accent || '';
    captionType = opts.captionType !== false;
    showCaption = opts.caption !== false;
    if (opts.title) { titleEl.hidden = false; titleEl.textContent = opts.title; }
    else { titleEl.hidden = true; titleEl.textContent = ''; }
    if (opts.seeAll && opts.seeAll.href) {
      seeEl.hidden = false;
      seeEl.setAttribute('href', opts.seeAll.href);
      seeEl.textContent = opts.seeAll.label || 'See all';
    } else { seeEl.hidden = true; seeEl.removeAttribute('href'); }
    /* Optional starting tab ('v' photos|videos): start is then the index within that
       filtered kind; otherwise 'all' and start indexes the full list. */
    tab = (opts.tab === 'v' || opts.tab === 'p') ? opts.tab : 'all';
    applyTab(start || 0);
    box.hidden = false;
    document.body.classList.add('kc-lightbox-open');
    var closeBtn = box.querySelector('.kc-lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  return { open: open, close: close };
})();

/*-------- KC ANIMATED SQUIGGLES --------
   One engine for every .kc-squiggle on the page. The path ships empty and is
   generated + rippled in JS using scroll velocity, mirroring the wave-divider
   engine and the v4 preview. Respects prefers-reduced-motion. */
(function () {
  var WAVE_W = 240;
  var WAVE_H = 16;

  function rngFromSeed(seed) {
    var s = (seed * 16807) % 2147483647;
    return function () {
      s = (s * 16807) % 2147483647;
      return s / 2147483647;
    };
  }

  /* Auto-inject a squiggle under the merch (product-list) heading. Only the
     KC-styled lists carry an eyebrow, so gate on that to avoid touching other
     product-list instances. */
  function injectMerchSquiggle() {
    var lists = document.querySelectorAll('[data-testid="product-list"]');
    for (var i = 0; i < lists.length; i++) {
      var section = lists[i];
      if (!section.querySelector('.product-list__eyebrow')) continue;
      var header = section.querySelector('.section-resource-list__header');
      if (!header || header.querySelector('.kc-squiggle')) continue;
      var heading = header.querySelector('h1, h2, h3, h4, h5, h6');
      if (!heading) continue;
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      // Unique hook so this one squiggle can be spaced on its own (it is built
      // differently from the Tour/Blogs squiggles - see below). Keep .kc-squiggle
      // too so the path-drawing engine still finds it.
      svg.setAttribute('class', 'kc-squiggle kc-squiggle--official-store');
      svg.setAttribute('viewBox', '0 0 240 16');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('data-seed', '4');
      // Absolutely position the squiggle under the heading text (inline styles so
      // Horizon's product-list CSS can't override them). Out of flow = it no longer
      // adds height to the header flex row, so the VIEW ALL button centers on the
      // heading text instead of on (heading + squiggle), which read as misaligned.
      // VERTICAL SPACING (top / margin-top) is intentionally NOT set here - it's in
      // assets/custom.css on .kc-squiggle--official-store so it stays tunable.
      svg.style.cssText = 'position:absolute;left:0;display:block;width:min(70px,22vw);height:16px;color:var(--coral,#E8896E);overflow:visible;pointer-events:none;';
      svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));
      heading.style.position = 'relative';
      heading.appendChild(svg);
    }
  }

  injectMerchSquiggle();

  var squiggles = [];
  var nodes = document.querySelectorAll('.kc-squiggle');
  for (var n = 0; n < nodes.length; n++) {
    var svg = nodes[n];
    var path = svg.querySelector('path');
    if (!path) continue;
    var seed = parseInt(svg.dataset.seed || '1', 10);
    var rand = rngFromSeed(seed * 7777);
    squiggles.push({
      svg: svg,
      path: path,
      baseAmp: 1.5 + rand() * 0.5,
      velAmp: 4,
      freq: 1.8 + rand() * 0.4,
      phase: rand() * Math.PI * 2,
      speed: 0.0006 + rand() * 0.0003,
      baseline: WAVE_H * 0.5
    });
  }

  if (!squiggles.length) return;

  function renderPath(sq, t, velocity) {
    var STEPS = 32;
    var vAbs = Math.min(100, Math.abs(velocity));
    var vMag = Math.sqrt(vAbs / 100);
    var vDir = velocity < 0 ? -1 : (velocity > 0 ? 1 : 0);
    var pts = [];
    for (var i = 0; i <= STEPS; i++) {
      var x = (WAVE_W / STEPS) * i;
      var u = x / WAVE_W;
      var amp = sq.baseAmp + sq.velAmp * vMag;
      var phaseShift = vDir * sq.freq * vMag * 1.2;
      var y = sq.baseline + Math.sin(u * Math.PI * 2 * sq.freq + sq.phase + t * sq.speed * 1000 + phaseShift) * amp;
      pts.push({ x: x, y: y });
    }
    var d = 'M0,' + pts[0].y.toFixed(2);
    for (var j = 0; j < pts.length - 1; j++) {
      var p0 = pts[Math.max(0, j - 1)];
      var p1 = pts[j];
      var p2 = pts[j + 1];
      var p3 = pts[Math.min(pts.length - 1, j + 2)];
      var t1x = p1.x + (p2.x - p0.x) / 6;
      var t1y = p1.y + (p2.y - p0.y) / 6;
      var t2x = p2.x - (p3.x - p1.x) / 6;
      var t2y = p2.y - (p3.y - p1.y) / 6;
      d += ' C' + t1x.toFixed(2) + ',' + t1y.toFixed(2) + ' ' + t2x.toFixed(2) + ',' + t2y.toFixed(2) + ' ' + p2.x.toFixed(2) + ',' + p2.y.toFixed(2);
    }
    return d;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    for (var r = 0; r < squiggles.length; r++) {
      squiggles[r].path.setAttribute('d', renderPath(squiggles[r], 0, 0));
    }
    return;
  }

  /* Shared scroll-velocity tracking with low-pass smoothing — gives the lines
     "memory" so they keep rolling briefly after you stop scrolling. */
  var lastY = window.scrollY;
  var raw = 0;
  var smooth = 0;
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    raw = y - lastY;
    lastY = y;
  }, { passive: true });

  var start = performance.now();
  function tick(now) {
    var t = (now - start) / 1000;
    smooth += (raw - smooth) * 0.08;
    var v = Math.max(-200, Math.min(200, smooth));
    raw *= 0.88;
    for (var i = 0; i < squiggles.length; i++) {
      var sq = squiggles[i];
      var rect = sq.svg.getBoundingClientRect();
      if (rect.bottom < -50 || rect.top > window.innerHeight + 50) continue;
      sq.path.setAttribute('d', renderPath(sq, t, v));
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
})();

/*-------- MYSTERY DROP CARDS: pointer tilt on hover --------
   Same teeter-totter as the next-show spotlight card (custom.js ~2360) and Eric's
   music section: cursor position maps to a small rotateY/rotateX + scale. Pointer
   devices only, off for reduced-motion. Stops once a card is revealed (drop passed). */
(function () {
  if (!window.matchMedia ||
      !window.matchMedia('(hover: hover)').matches ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function bindTilt(card) {
    if (card.dataset.kcTilt) return;
    card.dataset.kcTilt = '1';
    card.style.transformStyle = 'preserve-3d';
    card.style.willChange = 'transform';
    card.style.transition = 'transform 0.35s ease';
    card.addEventListener('mousemove', function (e) {
      if (!card.classList.contains('kc-mystery')) { card.style.transform = ''; return; }
      var r = card.getBoundingClientRect();
      var px = ((e.clientX - r.left) / r.width - 0.5) * 2;
      var py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      card.style.transform =
        'perspective(1000px) rotateY(' + (px * 5).toFixed(1) + 'deg) rotateX(' + (-py * 6).toFixed(1) + 'deg) scale(1.02)';
    });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; });
  }

  function initTilt() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-card.kc-mystery'), bindTilt);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTilt);
  } else {
    initTilt();
  }
  document.addEventListener('shopify:section:load', initTilt);
})();

/*-------- KC MYSTERY DROP COUNTDOWN --------
   Ticks every .kc-mystery-layer countdown and removes the teaser (revealing the
   real product) once the drop time passes. The Notify Me button carries the
   klaviyo-bis-trigger class so Klaviyo handles it once installed; until then a
   fallback focuses the page's email-capture field so the demo still works. */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function set(root, sel, val) {
    var el = root.querySelector(sel);
    if (el) el.textContent = val;
  }

  function reveal(node) {
    if (node.classList.contains('kc-mystery-layer')) {
      // Product card: drop the overlay so the real product shows.
      var card = node.closest('.product-card');
      if (card) card.classList.remove('kc-mystery');
    } else if (node.classList.contains('kc-pdp-lock')) {
      // Product page gate: re-enable the real content, then remove the gate.
      var pos = node.closest('.kc-pdp-lock-pos');
      var content = pos && pos.querySelector('.kc-pdp-lock-content');
      if (content) content.removeAttribute('inert');
    }
    node.remove();
  }

  function tick() {
    var nodes = document.querySelectorAll('[data-kc-drop]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var ts = parseInt(node.getAttribute('data-kc-drop'), 10) * 1000;
      var diff = ts - Date.now();

      if (diff <= 0) {
        reveal(node);
        continue;
      }

      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;

      set(node, '[data-d]', d);
      set(node, '[data-h]', pad(h));
      set(node, '[data-m]', pad(m));
      set(node, '[data-s]', pad(s));
    }
  }

  /* Notify-me / mailing-list popup. Clicking a mystery card or a #mailing-list
     trigger opens a navy modal that captures first/last/email/phone (+ birthday
     after success). On submit it posts to the signup endpoint, which upserts a
     Shopify customer (interim source of truth). When Klaviyo is installed we bail
     before opening so Klaviyo handles it instead. */
  var modal = null;

  /* Interim signup capture: post to the kc-instagram-feed service, which upserts
     a Shopify customer (first/last/email/phone + birthday metafield + newsletter
     tag + consent). Provider-agnostic until an ESP is chosen. Fire-and-forget so
     the success UI never waits on the network. */
  var SIGNUP_ENDPOINT = 'https://kc-cloudflare-feed.sparkart.workers.dev/signup';
  var lastSignupEmail = '';
  var lastFocus = null;
  function postSignup(data) {
    try {
      fetch(SIGNUP_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).catch(function () {});
    } catch (e) {}
  }

  // Auto-format MM/DD/YYYY as the user types.
  function formatBirthday(v) {
    var d = String(v).replace(/\D/g, '').slice(0, 8);
    var out = d.slice(0, 2);
    if (d.length >= 3) out += '/' + d.slice(2, 4);
    if (d.length >= 5) out += '/' + d.slice(4, 8);
    return out;
  }
  // Auto-format (XXX) XXX-XXXX as the user types.
  function formatPhone(v) {
    var d = String(v).replace(/\D/g, '').slice(0, 10);
    if (!d) return '';
    if (d.length < 4) return '(' + d;
    if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
    return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
  }
  // Reformat on input; keep the caret at the end (fine for these short fields).
  function bindFormatter(input, fn) {
    if (!input) return;
    input.addEventListener('input', function () {
      var atEnd = input.selectionStart === input.value.length;
      input.value = fn(input.value);
      if (atEnd) {
        try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
      }
    });
  }

  function formHTML(opts) {
    opts = opts || {};
    var title = opts.title || 'Mystery Drop';
    var text = opts.text || 'This item is currently unavailable. Add your email and we’ll let you know the moment it’s ready to purchase.';
    var submit = opts.submit || 'Notify Me When Available';
    var phoneField = opts.phone
      ? '<input type="tel" class="kc-notify-modal__input kc-notify-modal__input--phone" placeholder="Mobile (optional)" aria-label="Mobile number (optional)" autocomplete="tel">'
      : '';
      var disclaimersHTML = "By submitting this form, you consent to receive marketing communications from Kenny Chesney at the email and phone number provided. Consent is not a condition of any purchase. You can unsubscribe at any time by opting out or clicking the unsubscribe link (where available) in one of our messages. View our <a href='/pages/privacy-policy' target='_blank'>Privacy Policy</a> and <a href='/pages/terms-of-service' target='_blank'>Terms of Service</a>."
    return '<button type="button" class="kc-notify-modal__close" data-kc-close aria-label="Close">&times;</button>' +
      '<h2 class="kc-notify-modal__title" id="kc-notify-title">' + title + '</h2>' +
      '<p class="kc-notify-modal__text">' + text + '</p>' +
      '<form class="kc-notify-modal__form" novalidate>' +
        '<div class="kc-notify-modal__row">' +
          '<input type="text" class="kc-notify-modal__input kc-notify-modal__input--first" placeholder="First name" aria-label="First name" required autocomplete="given-name">' +
          '<input type="text" class="kc-notify-modal__input kc-notify-modal__input--last" placeholder="Last name" aria-label="Last name" required autocomplete="family-name">' +
        '</div>' +
        '<input type="email" class="kc-notify-modal__input" placeholder="Email" aria-label="Email address" required autocomplete="email">' +
        phoneField +
        '<label class="kc-notify-modal__check"><input type="checkbox" checked> I’d like to receive emails from Kenny</label>' +
        '<button type="submit" class="kc-notify-modal__submit">' + submit + '</button>' +
      '</form><br />' + 
      '<p class="kc-notify-modal__text"><small>' + disclaimersHTML + '</small></p>';
  }

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'kc-notify-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'kc-notify-title');
    modal.innerHTML =
      '<div class="kc-notify-modal__backdrop" data-kc-close></div>' +
      '<div class="kc-notify-modal__dialog"></div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-kc-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
    /* Keep Tab focus inside the open dialog. */
    modal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || modal.hidden) return;
      var dialog = modal.querySelector('.kc-notify-modal__dialog');
      var f = dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function bindForm() {
    var form = modal.querySelector('.kc-notify-modal__form');
    if (!form) return;
    bindFormatter(form.querySelector('.kc-notify-modal__input--phone'), formatPhone);
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // First / last name are required.
      var first = form.querySelector('.kc-notify-modal__input--first');
      var last = form.querySelector('.kc-notify-modal__input--last');
      var nameMissing = false;
      [first, last].forEach(function (field) {
        if (!field) return;
        if (!(field.value || '').trim()) {
          field.classList.add('kc-notify-modal__input--error');
          field.setAttribute('aria-invalid', 'true');
          nameMissing = true;
        } else {
          field.classList.remove('kc-notify-modal__input--error');
          field.removeAttribute('aria-invalid');
        }
      });
      if (nameMissing) {
        (first && !(first.value || '').trim() ? first : last).focus();
        return;
      }

      var input = form.querySelector('input[type="email"]');
      var val = (input.value || '').trim();
      if (!val || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(val)) {
        input.classList.add('kc-notify-modal__input--error');
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      // Mobile is optional — only validate it when the visitor typed something.
      var phone = form.querySelector('.kc-notify-modal__input--phone');
      if (phone) {
        var pval = (phone.value || '').trim();
        if (pval && pval.replace(/[^\d]/g, '').length < 7) {
          phone.classList.add('kc-notify-modal__input--error');
          phone.setAttribute('aria-invalid', 'true');
          phone.focus();
          return;
        }
        phone.removeAttribute('aria-invalid');
      }
      lastSignupEmail = val;
      postSignup({
        email: val,
        first_name: first ? (first.value || '').trim() : '',
        last_name: last ? (last.value || '').trim() : '',
        phone: phone ? (phone.value || '').trim() : ''
      });
      showSuccess();
    });
  }

  function openModal(opts) {
    lastFocus = document.activeElement;
    if (!modal) buildModal();
    var dialog = modal.querySelector('.kc-notify-modal__dialog');
    dialog.innerHTML = formHTML(opts);
    bindForm();
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var input = dialog.querySelector('.kc-notify-modal__input');
    if (input) setTimeout(function () { input.focus(); }, 30);
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    /* Return focus to whatever opened the modal. */
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); lastFocus = null; }
  }

  function showSuccess() {
    var dialog = modal.querySelector('.kc-notify-modal__dialog');
    var logo = window.KC_NSN_LOGO
      ? '<img class="kc-notify-modal__logo" src="' + window.KC_NSN_LOGO + '" alt="No Shoes Nation" width="200" height="129">'
      : '<div class="kc-notify-modal__check-icon" aria-hidden="true">✓</div>';
    dialog.innerHTML =
      '<button type="button" class="kc-notify-modal__close" data-kc-close aria-label="Close">&times;</button>' +
      '<div class="kc-notify-modal__success">' +
        logo +
        '<h2 class="kc-notify-modal__title" tabindex="-1">Welcome to No Shoes Nation</h2>' +
        '<p class="kc-notify-modal__text">You’re officially on the list. Keep an eye on your inbox for first looks, tour news, and more.</p>' +
        '<form class="kc-notify-modal__bday" novalidate>' +
          '<label class="kc-notify-modal__bday-label" for="kc-bday">Add your birthday for a little something on your special day 🎂🎉</label>' +
          '<div class="kc-notify-modal__bday-row">' +
            '<input type="text" id="kc-bday" class="kc-notify-modal__input kc-notify-modal__bday-input" placeholder="MM/DD/YYYY (optional)" inputmode="numeric" autocomplete="bday" maxlength="14" aria-label="Birthday (optional)">' +
            '<button type="submit" class="kc-notify-modal__bday-save">Let’s Go</button>' +
          '</div>' +
        '</form>' +
      '</div>';

    /* Move focus to the success heading so screen readers announce the new state. */
    var successTitle = dialog.querySelector('.kc-notify-modal__title');
    if (successTitle) setTimeout(function () { successTitle.focus(); }, 30);

    // Optional birthday capture (progressive profiling, like Hey Now Records).
    var bday = dialog.querySelector('.kc-notify-modal__bday');
    bindFormatter(dialog.querySelector('.kc-notify-modal__bday-input'), formatBirthday);
    if (bday) {
      bday.addEventListener('submit', function (e) {
        e.preventDefault();
        var field = bday.querySelector('.kc-notify-modal__bday-input');
        if (!field || !(field.value || '').trim()) return;
        if (lastSignupEmail) postSignup({ email: lastSignupEmail, birthday: (field.value || '').trim() });
        bday.innerHTML = '<p class="kc-notify-modal__bday-thanks">Thanks. We’ll celebrate with you.</p>';
      });
    }
  }

  /* Capture phase so we beat the card's stretched link + view-transition handler. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest('.product-card.kc-mystery');
    if (!card) return;
    if (window.klaviyo || window._klOnsite) return; // Klaviyo present: let it handle.
    e.preventDefault();
    e.stopPropagation();
    var titleEl = card.querySelector('.kc-mystery-title');
    openModal({ title: titleEl ? titleEl.textContent.trim() : 'Notify Me' });
  }, true);

  /* Mailing-list popup triggers — the topbar "Get Connected" button plus any
     link pointing at #mailing-list. Opens the same newsletter signup popup, and
     bails to Klaviyo's form once Klaviyo is installed. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kc-connect], a[href$="#mailing-list"]');
    if (!btn) return;
    if (window.klaviyo || window._klOnsite) return; // Klaviyo present: let it handle.
    e.preventDefault();
    openModal({
      title: 'Sign Up Today',
      text: "Join Kenny's mailing list for new music, tour alerts, and exclusive merch pre-orders in Kenny's store.",
      submit: 'Join the List',
      phone: true
    });
  });

  tick();
  setInterval(tick, 1000);
})();

/*-------- KC: expose sticky topbar height for the mobile drawer offset --------*/
(function () {
  function setTopbarHeight() {
    var tb = document.querySelector('.kc-topbar');
    var h = tb ? Math.round(tb.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--kc-topbar-h', h + 'px');
  }
  setTopbarHeight();
  window.addEventListener('resize', setTopbarHeight);
  window.addEventListener('load', setTopbarHeight);
})();

/*-------- SOFTEN GRIT OVERLAY OVER SELECT SECTIONS --------
   The grit (#fixed-noise-overlay = bg-noise.gif + bg-smoke.mp4) is a single
   fixed, full-viewport layer, so it can't be dialed back per-section in CSS.
   Instead, watch the Split Showcase + Social Pulse sections and ease the
   overlay's opacity (via CSS vars) while either dominates the viewport.
   rootMargin shrinks the trigger zone to the center 50% so the softening
   kicks in when the section is front-and-center, not at the scroll seams. */
(function () {
  var overlay = document.getElementById('fixed-noise-overlay');
  if (!overlay) return;

  // Load the 1MB smoke video only on desktop. On mobile it's barely perceptible
  // but steals bandwidth the hero LCP needs, so its src is held in data-grit-smoke
  // and attached here only when the viewport is desktop-sized.
  var smoke = overlay.querySelector('video[data-grit-smoke]');
  if (smoke && window.matchMedia('(min-width: 750px)').matches) {
    smoke.src = smoke.getAttribute('data-grit-smoke');
    smoke.autoplay = true;
    var p = smoke.play && smoke.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Split Showcase = [id$="__section_mrBJEB"] (stable across theme duplication);
  // Social Pulse = .kc-social-pulse.
  var targets = document.querySelectorAll('.kc-social-pulse, [id$="__section_mrBJEB"]');
  if (!targets.length) return;

  var root = document.documentElement;
  var SOFT_NOISE = '0.03'; // dialed further down from 0.15 default
  var SOFT_SMOKE = '0.1';  // dialed further down from 0.4 default
  var visible = new Set();

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) visible.add(e.target);
      else visible.delete(e.target);
    });
    if (visible.size) {
      root.style.setProperty('--grit-noise-opacity', SOFT_NOISE);
      root.style.setProperty('--grit-smoke-opacity', SOFT_SMOKE);
    } else {
      root.style.removeProperty('--grit-noise-opacity');
      root.style.removeProperty('--grit-smoke-opacity');
    }
  }, { threshold: 0, rootMargin: '-25% 0px -25% 0px' });

  targets.forEach(function (t) { io.observe(t); });
})();

/*-------- MOBILE DRAWER: parent caret opens submenu, title links through --------*/
/* In the 3-level mobile menu the parent row is split: the title is a real <a>
   that navigates to its own page (e.g. SHOP -> /collections), and the caret is a
   <button class="kc-drawer-parent-toggle"> that opens the slide-out submenu.
   Horizon's open() handler (on the button) reveals/animates the panel and traps
   focus, but it does NOT set the native `open` attribute on the <details> -- and
   the submenu is display:none until that attribute is present. We set it here so
   the panel actually shows. Closing is handled by Horizon's stock back button. */
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('.kc-drawer-parent-toggle');
    if (!toggle) return;
    var details = toggle.closest('details');
    if (details && !details.open) details.setAttribute('open', '');
  });
})();

/*-------- KC MUSIC TIMELINE (sections/music-timeline.liquid) --------
   Builds the interactive album timeline from the JSON the section emits:
   orders albums by release date, renders album covers + sticky rails (left =
   album scrubber, right = related media + products) on desktop / a pinned
   album navigator bar on mobile, morphs the background to each album's accent
   color on scroll, and drives the per-album media popup. Styles live in the
   section's {% stylesheet %} block. Visible classes follow the
   kc-music-timeline BEM naming used across the rest of the theme. */
(function () {
  var roots = document.querySelectorAll('[data-music-timeline]');
  if (!roots.length) return;

  var B = 'kc-music-timeline';
  var IC = B + '__ic';
  var ICON_PLAY = '<svg class="' + IC + '" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
  var ICON_PHOTO = '<svg class="' + IC + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>';
  var ICON_X = '<svg class="' + IC + ' ' + IC + '--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escAttr(s) { return esc(s).replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function cssUrl(u) { return "'" + String(u).replace(/\\/g, '\\\\').replace(/'/g, "\\'") + "'"; }
  function prefersReduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  /* Accent highlight: keep the album accent's hue but make it vivid + bright so the
     active accent reads on the accent-tinted background (the rails sit on the morphing
     color). Lightening toward white desaturates; instead we raise saturation and
     lightness in HSL so the color stays colorful. */
  function accentHighlight(hex) {
    var h = String(hex == null ? '' : hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return hex;
    var r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b), d = max - min;
    var l = (max + min) / 2, s = 0, hue = 0;
    if (d) {
      s = d / (1 - Math.abs(2 * l - 1));
      if (max === r) hue = ((g - b) / d) % 6;
      else if (max === g) hue = (b - r) / d + 2;
      else hue = (r - g) / d + 4;
      hue = hue * 60; if (hue < 0) hue += 360;
    }
    s = Math.min(1, Math.max(0.62, s * 1.2));
    return 'hsl(' + Math.round(hue) + ', ' + Math.round(s * 100) + '%, 66%)';
  }
  /* Darken toward black for the bottom of the era gradient (the "deep" tone). */
  function darkenHex(hex, amt) {
    var h = String(hex == null ? '' : hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return hex;
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    r = Math.round(r * (1 - amt)); g = Math.round(g * (1 - amt)); b = Math.round(b * (1 - amt));
    return 'rgb(' + r + ',' + g + ',' + b + ')';
  }
  /* Darken a too-light accent so the cream display/rail text keeps ~3:1 contrast on the
     morphing background, without flattening accents that are already dark enough. */
  function contrastField(hex) {
    var h = String(hex == null ? '' : hex).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return hex;
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    var lin = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    var L = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
    var creamL = 0.90; // approx relative luminance of #fbf6ec
    if ((creamL + 0.05) / (L + 0.05) >= 3) return hex; // already legible
    var targetL = (creamL + 0.05) / 3 - 0.05;          // L that yields 3:1 for cream text
    var factor = Math.max(0.28, Math.min(1, Math.sqrt(Math.max(targetL, 0) / Math.max(L, 0.0001))));
    return 'rgb(' + Math.round(r * factor) + ',' + Math.round(g * factor) + ',' + Math.round(b * factor) + ')';
  }
  function youTubeId(url) {
    if (!url) return null;
    var m = String(url).match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : null;
  }
  function youTubeEmbed(id, label, cls) {
    return '<iframe class="' + cls + '" src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1" title="' + escAttr(label) + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>';
  }

  [].forEach.call(roots, function (root) {
    if (root.dataset.mtInit) return;
    root.dataset.mtInit = '1';
    try { initTimeline(root); } catch (e) { /* leave the no-JS fallback in place */ }
  });

  function initTimeline(root) {
    var dataEl = root.querySelector('[data-mt-data]');
    var mount = root.querySelector('[data-mt-mount]');
    var view = root.querySelector('[data-kc-mt-view]') || mount;
    if (!dataEl || !mount) return;

    var data = JSON.parse(dataEl.textContent);
    var albums = data.albums || [];
    if (!albums.length) { mount.innerHTML = '<p class="' + B + '__loading">No albums to show yet.</p>'; return; }

    albums.forEach(function (a) {
      a.year = a.year == null ? null : parseInt(a.year, 10);
      a.ts = a.ts == null ? null : parseInt(a.ts, 10);
    });

    /* Order strictly by release date, newest first. */
    var flat = albums.slice().sort(function (a, b) {
      var at = a.ts == null ? (a.year == null ? -Infinity : a.year * 31557600) : a.ts;
      var bt = b.ts == null ? (b.year == null ? -Infinity : b.year * 31557600) : b.ts;
      return bt - at;
    });
    flat.forEach(function (a, i) { a.idx = i; });

    var watchLabel = data.watchLabel || 'Watch & See';
    var seeAllLabel = data.seeAllLabel || 'See all on the album page';
    var playLabel = data.playLabel || 'Watch Videos';
    var openLabel = data.openLabel || 'Open';
    var showDisco = data.showDisco !== false;
    var showMediaRow = !!data.showMediaRow;
    var showRailLabels = !!data.showRailLabels;
    var showOpenAlbum = !!data.showOpenAlbum;
    var showShop = data.showShop !== false;
    var showDiscoThumbs = !!data.showDiscoThumbs;
    var showMetaType = data.showMetaType !== false;

    /* Fallback page-background color for an album with no accent_color set. */
    var ACCENT_FALLBACK = '#0b1830';


    var albumsHTML = flat.map(function (a) {
      var hasCover = !!a.cover;
      var coverCls = B + '__cover' + (hasCover ? '' : ' is-placeholder');
      /* Cover artwork as a real <img>: lazy-loaded off-screen (the first/newest album
         is the LCP, so it loads eagerly with high priority), and alt text makes it
         crawlable for image search. Placeholder albums keep the accent-color tile. */
      var coverInner, placeStyle;
      if (hasCover) {
        var prio = a.idx === 0 ? ' fetchpriority="high"' : ' loading="lazy"';
        coverInner = '<img class="' + B + '__cover-img" src="' + escAttr(a.cover) + '" alt="' + escAttr(a.title + ' album cover') + '"' + prio + ' decoding="async" draggable="false">';
        placeStyle = '';
      } else {
        coverInner = '<span class="' + B + '__cover-title">' + esc(a.title) + '</span>';
        placeStyle = ' style="background-color:' + (a.accent || ACCENT_FALLBACK) + ';"';
      }
      var cover = a.url
        ? '<a class="' + coverCls + '" data-idx="' + a.idx + '" href="' + escAttr(a.url) + '"' + placeStyle + ' aria-label="' + escAttr(a.title) + '">' + coverInner + '</a>'
        : '<div class="' + coverCls + '" data-idx="' + a.idx + '"' + placeStyle + '>' + coverInner + '</div>';
      var meta = [];
      if (a.type && showMetaType) meta.push(esc(a.type));
      /* "Releases" (future tense) for an album whose date hasn't arrived yet, else "Released". */
      var isFuture = a.ts != null ? (a.ts * 1000 > Date.now()) : (a.year != null && a.year > new Date().getFullYear());
      var relVerb = isFuture ? 'Releases ' : 'Released ';
      if (a.date) meta.push(relVerb + esc(a.date)); else if (a.year) meta.push(relVerb + a.year);
      var hasMedia = a.media && a.media.length;
      /* Button order: Pre-order (pre-order albums only), Pre-save/Pre-add (when the album
         has a smart link), then a "View the single/album" link to the album page. The
         related media + shop live in the right flank, so no buttons for those here. */
      var actions = '';
      if (showShop && a.preorder && a.url) {
        actions += '<a class="' + B + '__btn ' + B + '__btn--shop ' + B + '__btn--preorder" href="' + escAttr(a.url) + '#kc-ad-shop">' +
          '<span>Pre-order</span></a>';
      }
      /* Pre-save / pre-add: opens the album's smart link (Spotify/Apple) when set. */
      if (a.presave && a.presave.url) {
        actions += '<a class="' + B + '__btn ' + B + '__btn--presave" href="' + escAttr(a.presave.url) + '" target="_blank" rel="noopener">' +
          '<span>' + esc(a.presave.text || 'Pre-save') + '</span></a>';
      }
      if (a.url) {
        var viewLabel = (a.type && /single/i.test(a.type)) ? 'View the single' : 'View the album';
        actions += '<a class="' + B + '__btn ' + B + '__btn--view" href="' + escAttr(a.url) + '">' +
          '<span>' + viewLabel + '</span></a>';
      }
      var mediaBlock = (showMediaRow && hasMedia)
        ? '<p class="' + B + '__media-label">' + esc(watchLabel) + ' from <i>' + esc(a.title) + '</i></p>' +
          '<div class="' + B + '__media" data-media-for="' + a.idx + '"></div>'
        : '';
      var albumId = a.handle ? (' id="kc-mt-album-' + escAttr(a.handle) + '"') : '';
      return '<article class="' + B + '__album"' + albumId + ' data-idx="' + a.idx + '">' +
        '<div class="' + B + '__coverwrap">' +
          (a.disc ? '<a class="' + B + '__disc"' + (a.url ? ' href="' + escAttr(a.url) + '"' : '') + ' aria-hidden="true" tabindex="-1"><span class="' + B + '__disc-spin" style="background-image:url(' + cssUrl(a.disc) + ');"></span></a>' : '') + cover +
        '</div>' +
        '<div class="' + B + '__album-info">' +
          '<h3 class="' + B + '__album-title">' + esc(a.title) + '</h3>' +
          (meta.length ? '<div class="' + B + '__meta">' + meta.join(' &middot; ') + '</div>' : '') +
          (actions ? '<div class="' + B + '__actions">' + actions + '</div>' : '') +
          mediaBlock +
        '</div></article>';
    }).join('');

    /* One scrubber row per album (year + title, optional cover thumb). Used for the
       left-flank album scrubber and the mobile dropdown jump menu. */
    function discoRow(a, withThumb) {
      var dthumb = a.coverThumb || a.cover;
      var thumb = withThumb
        ? '<span class="' + B + '__disco-thumb"' + (dthumb ? ' style="background-image:url(' + cssUrl(dthumb) + ');"' : '') + ' aria-hidden="true"></span>'
        : '';
      return '<button class="' + B + '__disco-item" type="button" data-idx="' + a.idx + '">' +
        thumb +
        '<span class="' + B + '__disco-year">' + (a.year ? a.year : '') + '</span>' +
        '<span class="' + B + '__disco-text"><span class="' + B + '__disco-title">' + esc(a.title) + '</span></span>' +
        '</button>';
    }
    var discoHTML = showDisco ? flat.map(function (a) { return discoRow(a, showDiscoThumbs); }).join('') : '';
    var mobileListHTML = flat.map(function (a) { return discoRow(a, true); }).join('');

    var ICON_CARET = '<svg class="' + IC + ' ' + IC + '--sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

    mount.innerHTML =
      /* Mobile: current album (thumb + title + year) on the left, a dropdown that
         expands the full album list (current selected) to jump quickly. */
      '<div class="' + B + '__mobilebar">' +
        '<div class="' + B + '__mobilebar-current">' +
          '<span class="' + B + '__mobilebar-thumb" aria-hidden="true"></span>' +
          '<span class="' + B + '__mobilebar-text"><span class="' + B + '__mobilebar-name"></span><span class="' + B + '__mobilebar-meta"></span></span>' +
        '</div>' +
        '<button class="' + B + '__mobilebar-toggle" type="button" aria-label="Jump to album" aria-expanded="false">' + ICON_CARET + '</button>' +
        '<div class="' + B + '__mobilebar-menu" hidden>' + mobileListHTML + '</div>' +
      '</div>' +
      '<div class="' + B + '__grid' + (showDisco ? '' : ' is-no-disco') + '">' +
        /* Left flank = the album scrubber (the timeline of albums). */
        '<aside class="' + B + '__rail ' + B + '__rail--left">' +
          '<div class="' + B + '__panel">' +
            '<div class="' + B + '__now">' +
              (showRailLabels ? '<p class="' + B + '__rail-kicker">Now viewing</p>' : '') +
              '<h3 class="' + B + '__now-album"></h3>' +
              '<p class="' + B + '__now-year"></p>' +
            '</div>' +
            (showDisco
              ? (showRailLabels ? '<p class="' + B + '__rail-kicker">Albums</p>' : '') +
                '<div class="' + B + '__disco' + (showDiscoThumbs ? ' ' + B + '__disco--thumbs' : '') + '">' + discoHTML + '</div>'
              : '') +
          '</div>' +
        '</aside>' +
        '<div class="' + B + '__track">' + albumsHTML + '</div>' +
        /* Right flank = related media thumbnails + a related-products strip. */
        '<aside class="' + B + '__rail ' + B + '__rail--right">' +
          '<div class="' + B + '__panel">' +
            '<div class="' + B + '__flank-section ' + B + '__flank-section--products">' +
              '<p class="' + B + '__flank-title">Shop</p>' +
              '<div class="' + B + '__flank-products" data-flank-products></div>' +
            '</div>' +
            '<div class="' + B + '__flank-section ' + B + '__flank-section--photos">' +
              '<p class="' + B + '__flank-title">Photos</p>' +
              '<div class="' + B + '__flank-media" data-flank-photos></div>' +
            '</div>' +
            '<div class="' + B + '__flank-section ' + B + '__flank-section--videos">' +
              '<p class="' + B + '__flank-title">Videos</p>' +
              '<div class="' + B + '__flank-media" data-flank-videos></div>' +
            '</div>' +
          '</div>' +
        '</aside>' +
      '</div>';

    var leftRail = mount.querySelector('.' + B + '__rail--left');
    var disco = mount.querySelector('.' + B + '__disco');
    var discoItems = disco ? [].slice.call(disco.querySelectorAll('.' + B + '__disco-item')) : [];
    var nowAlbum = mount.querySelector('.' + B + '__now-album');
    var nowYear = mount.querySelector('.' + B + '__now-year');
    /* Right-flank related media + products for the active album. */
    var flankPhotos = mount.querySelector('[data-flank-photos]');
    var flankVideos = mount.querySelector('[data-flank-videos]');
    var flankProducts = mount.querySelector('[data-flank-products]');
    var flankSecPhotos = mount.querySelector('.' + B + '__flank-section--photos');
    var flankSecVideos = mount.querySelector('.' + B + '__flank-section--videos');
    var flankSecProducts = mount.querySelector('.' + B + '__flank-section--products');
    var flankProductsTitle = flankSecProducts ? flankSecProducts.querySelector('.' + B + '__flank-title') : null;

    /* On desktop, pin the page heading to the top of the left sticky flank; it
       fades away as soon as you scroll down. On mobile it returns to its
       original spot above the timeline. */
    var headerEl = root.querySelector('.' + B + '__header');
    if (headerEl && leftRail) {
      var headerHome = headerEl.parentNode;
      var headerNext = headerEl.nextSibling;
      var deskMQ = window.matchMedia('(min-width: 990px)');
      var placeHeading = function () {
        if (deskMQ.matches) {
          if (headerEl.parentNode !== leftRail) leftRail.insertBefore(headerEl, leftRail.firstChild);
          headerEl.classList.add(B + '__header--in-rail');
        } else {
          headerEl.classList.remove(B + '__header--in-rail', 'is-scrolled');
          /* On mobile, sit the page title just below the sticky album bar. */
          var bar = mount.querySelector('.' + B + '__mobilebar');
          if (bar && bar.parentNode) {
            if (headerEl !== bar.nextSibling) bar.parentNode.insertBefore(headerEl, bar.nextSibling);
          } else if (headerEl.parentNode !== headerHome) {
            headerHome.insertBefore(headerEl, headerNext);
          }
        }
      };
      placeHeading();
      if (deskMQ.addEventListener) deskMQ.addEventListener('change', placeHeading);
      else if (deskMQ.addListener) deskMQ.addListener(placeHeading);

      var hdrRaf = 0;
      var syncHeading = function () {
        hdrRaf = 0;
        var y = window.scrollY || window.pageYOffset || 0;
        headerEl.classList.toggle('is-scrolled', deskMQ.matches && y > 24);
      };
      window.addEventListener('scroll', function () {
        if (!hdrRaf) hdrRaf = requestAnimationFrame(syncHeading);
      }, { passive: true });
      syncHeading();
    }

    var mbThumb = mount.querySelector('.' + B + '__mobilebar-thumb');
    var mbName = mount.querySelector('.' + B + '__mobilebar-name');
    var mbMeta = mount.querySelector('.' + B + '__mobilebar-meta');
    var mbToggle = mount.querySelector('.' + B + '__mobilebar-toggle');
    var mbMenu = mount.querySelector('.' + B + '__mobilebar-menu');
    var mbMenuItems = mbMenu ? [].slice.call(mbMenu.querySelectorAll('.' + B + '__disco-item')) : [];
    var ROW_CAP = 7;
    var albumEls = [].slice.call(mount.querySelectorAll('.' + B + '__album'));

    /* Render the focused album's media as a horizontal row INTO its own inline
       container; only the active album loads thumbs, so the page stays light. */
    var mediaRowFor = -1;
    function renderMediaRow(a, idx) {
      if (mediaRowFor === idx) return;
      if (mediaRowFor >= 0 && albumEls[mediaRowFor]) {
        var prev = albumEls[mediaRowFor].querySelector('.' + B + '__media');
        if (prev) prev.innerHTML = '';
      }
      mediaRowFor = idx;
      var host = albumEls[idx] ? albumEls[idx].querySelector('.' + B + '__media') : null;
      if (!host) return;
      if (!a.media || !a.media.length) { host.innerHTML = ''; return; }
      /* Cap the preview row; the lightbox shows the full set. */
      var shown = a.media.slice(0, ROW_CAP);
      var extra = a.media.length - shown.length;
      host.innerHTML = shown.map(function (m, i) {
        var vid = m.k === 'v';
        var bg = m.thumb ? 'background-image:url(' + cssUrl(m.thumb) + ');' : '';
        var isMore = (i === shown.length - 1) && extra > 0;
        var overlay = isMore
          ? '<span class="' + B + '__thumb-more">+' + extra + '</span>'
          : (vid ? '<span class="' + B + '__playbadge">' + ICON_PLAY + '</span>' : (m.thumb ? '' : ICON_PHOTO));
        return '<button class="' + B + '__thumb" type="button" data-idx="' + a.idx + '" data-mi="' + i + '" style="' + bg + '" aria-label="' + escAttr(m.label) + '">' + overlay + '</button>';
      }).join('');
    }

    /* Right flank: the active album's related media split into Photos and Videos
       thumbnail grids (each opens the shared lightbox on its own tab), plus a
       related-products strip. Each section hides itself when the album has none. */
    var FLANK_CAP = 9; /* 3x3 grid max per section */
    /* Fill one kind-specific media grid; data-ki is the thumb's index WITHIN its kind
       (videos/photos), which is what the lightbox needs once the tab is pre-selected. */
    function fillMediaGrid(container, section, items, albumIdx, kind) {
      if (!container) return;
      if (!items.length) { container.innerHTML = ''; if (section) section.hidden = true; return; }
      var shown = items.slice(0, FLANK_CAP);
      var extra = items.length - shown.length;
      container.innerHTML = shown.map(function (m, i) {
        var bg = m.thumb ? 'background-image:url(' + cssUrl(m.thumb) + ');' : '';
        var isMore = (i === shown.length - 1) && extra > 0;
        var overlay = isMore
          ? '<span class="' + B + '__thumb-more">+' + extra + '</span>'
          : (kind === 'v' ? '<span class="' + B + '__playbadge">' + ICON_PLAY + '</span>' : (m.thumb ? '' : ICON_PHOTO));
        return '<button class="' + B + '__thumb" type="button" data-idx="' + albumIdx + '" data-kind="' + kind + '" data-ki="' + i + '" style="' + bg + '" aria-label="' + escAttr(m.label) + '">' + overlay + '</button>';
      }).join('');
      if (section) section.hidden = false;
    }
    function renderFlank(a) {
      var photos = [], videos = [];
      if (a.media) { a.media.forEach(function (m) { (m.k === 'v' ? videos : photos).push(m); }); }
      fillMediaGrid(flankPhotos, flankSecPhotos, photos, a.idx, 'p');
      fillMediaGrid(flankVideos, flankSecVideos, videos, a.idx, 'v');
      if (flankProducts) {
        if (a.products && a.products.length) {
          if (flankProductsTitle) flankProductsTitle.textContent = (a.type && /single/i.test(a.type)) ? 'Shop the Single' : 'Shop the Album';
          flankProducts.innerHTML = a.products.slice(0, FLANK_CAP).map(function (p) {
            var bg = p.image ? 'background-image:url(' + cssUrl(p.image) + ');' : '';
            return '<a class="' + B + '__product' + (p.image ? '' : ' is-placeholder') + '" href="' + escAttr(p.url) + '" style="' + bg + '" aria-label="' + escAttr(p.title || '') + '">' + (p.image ? '' : '<span>' + esc(p.title || '') + '</span>') + '</a>';
          }).join('');
          if (flankSecProducts) flankSecProducts.hidden = false;
        } else {
          flankProducts.innerHTML = '';
          if (flankSecProducts) flankSecProducts.hidden = true;
        }
      }
    }

    /* Keep the active album row vertically centered in the discography scrubber. */
    function centerDisco(idx) {
      var item = discoItems[idx];
      if (!item || !disco) return;
      var target = item.offsetTop - (disco.clientHeight / 2) + (item.offsetHeight / 2);
      try { disco.scrollTo({ top: target, behavior: prefersReduced() ? 'auto' : 'smooth' }); }
      catch (e) { disco.scrollTop = target; }
    }

    /* Vinyl spin: the focused disc rotates continuously; on focus it bursts up to
       speed then eases to a slow steady rotation (driven by the float rAF below). */
    var spinAngle = 0, spinVel = 0, spinEl = null;
    var SPIN_STEADY = 0.3, SPIN_BURST = 6.5;

    var curIdx = -1;
    function setActive(idx) {
      if (idx === curIdx) return;
      if (curIdx >= 0 && albumEls[curIdx]) albumEls[curIdx].classList.remove('is-focus');
      curIdx = idx;
      if (albumEls[idx]) albumEls[idx].classList.add('is-focus');
      if (!prefersReduced()) {
        spinEl = albumEls[idx] ? albumEls[idx].querySelector('.' + B + '__disc-spin') : null;
        spinAngle = 0; spinVel = SPIN_BURST;
      }
      var a = flat[idx];
      renderMediaRow(a, idx);
      renderFlank(a);
      if (discoItems.length) {
        discoItems.forEach(function (el, i) { el.classList.toggle('is-on', i === idx); });
        centerDisco(idx);
      }
      mbMenuItems.forEach(function (el, i) { el.classList.toggle('is-on', i === idx); });
      /* "Now viewing" header (left flank) tracks the active album. */
      if (nowAlbum) nowAlbum.textContent = a.title;
      if (nowYear) nowYear.textContent = a.year ? String(a.year) : '';
      /* Morph the page background to this album's accent color (field -> deep) plus a
         brightened accent tint for both flanks. Registered @property colors animate the
         change. Albums with no accent_color fall back to the neutral footer navy. */
      var accent = a.accent || ACCENT_FALLBACK;
      var field = contrastField(accent);
      view.style.setProperty('--kc-mt-field', field);
      view.style.setProperty('--kc-mt-deep', darkenHex(field, 0.5));
      view.style.setProperty('--kc-mt-accent', accentHighlight(accent));
      /* Mobile bar: active album mini-thumb + title + year. */
      if (mbThumb) { var mbt = a.coverThumb || a.cover; mbThumb.style.backgroundImage = mbt ? 'url(' + cssUrl(mbt) + ')' : ''; }
      if (mbName) mbName.textContent = a.title;
      if (mbMeta) mbMeta.textContent = a.year ? String(a.year) : (a.type || '');
    }

    var ratios = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { ratios[en.target.getAttribute('data-idx')] = en.isIntersecting ? en.intersectionRatio : 0; });
      var bestIdx = null, best = -1;
      Object.keys(ratios).forEach(function (k) { if (ratios[k] > best) { best = ratios[k]; bestIdx = k; } });
      if (bestIdx != null && best > 0) setActive(+bestIdx);
    }, { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: '-15% 0px -15% 0px' });
    [].forEach.call(mount.querySelectorAll('.' + B + '__album'), function (s) { io.observe(s); });

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches && !prefersReduced()) {
      [].forEach.call(mount.querySelectorAll('.' + B + '__cover'), function (cv) {
        var disc = cv.parentNode ? cv.parentNode.querySelector('.' + B + '__disc') : null;
        cv.addEventListener('mousemove', function (e) {
          var r = cv.getBoundingClientRect();
          var px = ((e.clientX - r.left) / r.width - 0.5) * 2, py = ((e.clientY - r.top) / r.height - 0.5) * 2;
          cv.style.transform = 'rotateY(' + (px * 9).toFixed(1) + 'deg) rotateX(' + (-py * 9).toFixed(1) + 'deg) scale(1.04)';
          /* Parallax the vinyl behind the cover so it drifts with the tilt. */
          if (disc) disc.style.transform = 'translate(calc(-22% + ' + (px * 11).toFixed(1) + 'px), calc(-50% + ' + (py * 11).toFixed(1) + 'px))';
        });
        cv.addEventListener('mouseleave', function () {
          cv.style.transform = '';
          if (disc) disc.style.transform = '';
        });
      });
    }

    /* Scroll position that centers an album in the visible area below the sticky header.
       The fixed topbar always occludes the top; the reveal-on-scroll-up site nav only
       occludes when the jump scrolls UP (which is what reveals it), so we reserve it
       only then — a down-jump hides the nav and centers below just the topbar. */
    function albumScrollTop(el) {
      /* Center the COVER (not the whole album box — the title/buttons sit below it, so
         the box center would leave the cover too high). The target album is focused
         first, so its cover has no entrance transform and the rect is accurate. */
      var coverEl = el.querySelector('.' + B + '__cover') || el;
      var rect = coverEl.getBoundingClientRect();
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var absCenter = rect.top + scrollY + rect.height / 2;
      var tb = document.querySelector('.kc-topbar');
      var hdr = document.getElementById('header-component');
      var topbarH = tb ? Math.max(0, tb.getBoundingClientRect().bottom) : 0;
      var navH = hdr ? hdr.offsetHeight : 0;
      var occ = topbarH;
      var target = absCenter - (occ + window.innerHeight) / 2;
      if (target < scrollY) { occ = topbarH + navH; target = absCenter - (occ + window.innerHeight) / 2; }
      return Math.max(0, Math.round(target));
    }
    function centerAlbum(el, smooth) {
      if (!el) return;
      var top = albumScrollTop(el);
      try { window.scrollTo({ top: top, behavior: (smooth && !prefersReduced()) ? 'smooth' : 'auto' }); }
      catch (e) { window.scrollTo(0, top); }
    }
    function jumpAlbum(idx) { setActive(idx); centerAlbum(albumEls[idx], true); }
    if (disco) disco.addEventListener('click', function (e) { var el = e.target.closest('.' + B + '__disco-item'); if (el) jumpAlbum(+el.getAttribute('data-idx')); });

    /* Mobile album navigator: the toggle opens/closes the dropdown list; picking a row
       jumps to that album and closes the menu. */
    function setMenu(open) {
      if (!mbMenu || !mbToggle) return;
      mbMenu.hidden = !open;
      mbToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mbToggle.classList.toggle('is-open', open);
      if (open && curIdx >= 0 && mbMenuItems[curIdx]) {
        mbMenuItems[curIdx].scrollIntoView({ block: 'nearest' });
      }
    }
    if (mbToggle) mbToggle.addEventListener('click', function () { setMenu(mbMenu && mbMenu.hidden); });
    if (mbMenu) mbMenu.addEventListener('click', function (e) {
      var el = e.target.closest('.' + B + '__disco-item');
      if (el) { setMenu(false); jumpAlbum(+el.getAttribute('data-idx')); }
    });
    document.addEventListener('click', function (e) {
      if (mbMenu && !mbMenu.hidden && !e.target.closest('.' + B + '__mobilebar')) setMenu(false);
    });

    /* Open the shared media lightbox (top of this file) for an album's media. kind
       ('v'|'p'|null) pre-selects the Videos/Photos tab; start is the index within that
       kind (or within all media when kind is null). Tabs + see-all + the album's accent
       are passed in; the lightbox handles inline YouTube/<video>, photos, nav, and Esc. */
    function openMedia(idx, kind, start) {
      var a = flat[idx];
      if (!a || !a.media || !a.media.length) return;
      var items = a.media.map(function (m) {
        var src = m.src;
        /* Photos ship only their 240px thumb; upscale the Shopify width param to
           full-res for the lightbox (external URLs without a width param pass through). */
        if (m.k === 'p' && !src && m.thumb) {
          src = /[?&]width=\d+/.test(m.thumb) ? m.thumb.replace(/([?&]width=)\d+/, '$11400') : m.thumb;
        }
        return { kind: m.k, label: m.label, src: src, thumb: m.thumb };
      });
      window.KCMediaLightbox.open(items, start || 0, {
        title: a.title,
        accent: a.accent || ACCENT_FALLBACK,
        tabs: true,
        tab: (kind === 'v' || kind === 'p') ? kind : null,
        captionType: false,
        seeAll: a.url ? { href: a.url + '#media', label: seeAllLabel } : null
      });
    }

    /* Open a shop thumbnail in Horizon's native quick-add modal (the shared
       #quick-add-dialog). We fetch the product page's grid content and inject it; the
       native variant picker + add-to-cart form self-initialize. Returns false when the
       dialog isn't on the page so the caller lets the link navigate normally. */
    function openProductQuickAdd(url) {
      var dialog = document.getElementById('quick-add-dialog');
      var content = document.getElementById('quick-add-modal-content');
      if (!url || !dialog || !content || typeof dialog.showDialog !== 'function') return false;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var grid = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-grid-content]');
        if (!grid) { window.location.href = url; return; }
        content.innerHTML = grid.innerHTML;
        dialog.showDialog();
      }).catch(function () { window.location.href = url; });
      return true;
    }

    mount.addEventListener('click', function (e) {
      var tb = e.target.closest('.' + B + '__thumb');
      if (tb) {
        var ai = +tb.getAttribute('data-idx');
        if (tb.hasAttribute('data-kind')) openMedia(ai, tb.getAttribute('data-kind'), +tb.getAttribute('data-ki'));
        else openMedia(ai, null, +tb.getAttribute('data-mi'));
        return;
      }
      /* Shop thumbnail -> native quick-add modal (modifier-clicks still open the product page). */
      var prod = e.target.closest('.' + B + '__product');
      if (prod && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) {
        if (openProductQuickAdd(prod.getAttribute('href'))) e.preventDefault();
      }
    });

    /* Inertia float: covers drift with scroll velocity and keep a gentle idle
       bob, settling when scrolling stops. Only on-screen covers animate. */
    if (!prefersReduced()) {
      var coverwraps = [].slice.call(mount.querySelectorAll('.' + B + '__coverwrap'));
      var fvis = {};
      var fio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = en.target.getAttribute('data-cw');
          if (en.isIntersecting) { fvis[i] = en.target; } else { delete fvis[i]; }
        });
      }, { rootMargin: '25% 0px 25% 0px' });
      coverwraps.forEach(function (cw, i) { cw.setAttribute('data-cw', i); cw.dataset.ph = (i * 1.7) % 6.283; fio.observe(cw); });
      var lastY = window.scrollY || window.pageYOffset || 0, rawV = 0, smV = 0;
      window.addEventListener('scroll', function () { var y = window.scrollY || window.pageYOffset || 0; rawV = y - lastY; lastY = y; }, { passive: true });
      var floatTick = function (now) {
        /* Vinyl spin: ease the angular velocity from the focus burst down to a slow
           steady rotation, accumulating the angle on the focused disc. */
        spinVel += (SPIN_STEADY - spinVel) * 0.025;
        spinAngle += spinVel;
        if (spinAngle >= 360) spinAngle -= 360;
        if (spinEl) spinEl.style.transform = 'rotate(' + spinAngle.toFixed(2) + 'deg)';
        smV += (rawV - smV) * 0.12;
        rawV *= 0.85;
        var v = Math.max(-60, Math.min(60, smV));
        for (var k in fvis) {
          var cw = fvis[k];
          if (!cw) continue;
          var ph = parseFloat(cw.dataset.ph) || 0;
          var y = Math.sin(now * 0.0009 + ph) * 4 - v * 0.38;
          var x = Math.cos(now * 0.0007 + ph) * 2.4 + v * 0.05 * ((+k % 2) ? 1 : -1);
          cw.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0)';
        }
        requestAnimationFrame(floatTick);
      };
      requestAnimationFrame(floatTick);
    }

    /* Dock the pinned mobile album bar below the site header (always-fixed topbar +
       reveal-on-scroll header), tracking the live bottom so it adapts when the
       header grows/reveals on scroll up. */
    var mobilebar = mount.querySelector('.' + B + '__mobilebar');
    var siteHeader = document.getElementById('header-component');
    var topBar = document.querySelector('.kc-topbar');
    if (mobilebar && (siteHeader || topBar)) {
      /* Persistent rAF, same as the rails below. A scroll/resize listener alone is
         not enough: the reveal-on-scroll header slides on a CSS transition that
         outlives the scroll event, so the bar would stay docked at a stale top and
         a gap opens under the header as it finishes sliding down. Tracking the live
         header bottom every frame keeps the bar flush; it only writes on change. */
      var lastBarTop = '';
      var tickBar = function () {
        var t = 0;
        if (topBar) t = Math.max(t, topBar.getBoundingClientRect().bottom);
        if (siteHeader) t = Math.max(t, siteHeader.getBoundingClientRect().bottom);
        var next = Math.max(0, Math.round(t)) + 'px';
        if (next !== lastBarTop) { lastBarTop = next; mobilebar.style.top = next; }
        requestAnimationFrame(tickBar);
      };
      requestAnimationFrame(tickBar);
    }

    /* Vertically center the sticky flank panels on the visible area rather than
       the full 100vh box. At the top of the page the rails overhang below the
       fold (their flow position starts at the grid top), which dropped the
       panels well below the first cover; trimming the height by that overhang
       lines them up with the first cover on load, and once the grid scrolls
       past the top the height is the full viewport again (centered like the
       other albums). */
    var railEls = [].slice.call(mount.querySelectorAll('.' + B + '__rail'));
    if (railEls.length) {
      /* Keep the sticky flanks docked just below the live header bottom so the
         reveal-on-scroll nav pushes them down (in sync with its slide) instead of
         covering them. A persistent rAF catches the header's tail animation too;
         it only writes when the offset actually changes. */
      var lastRailKey = '';
      var tickRails = function () {
        var top = 0;
        if (topBar) top = Math.max(top, topBar.getBoundingClientRect().bottom);
        if (siteHeader) top = Math.max(top, siteHeader.getBoundingClientRect().bottom);
        top = Math.max(0, Math.round(top));
        var vh = window.innerHeight;
        var key = top + ':' + vh;
        if (key !== lastRailKey) {
          lastRailKey = key;
          railEls.forEach(function (r) { r.style.top = top + 'px'; r.style.height = (vh - top) + 'px'; });
        }
        requestAnimationFrame(tickRails);
      };
      requestAnimationFrame(tickRails);
    }

    setActive(0);

    /* Arriving from an album page (…#kc-mt-album-<handle>) jumps to that album. */
    if (location.hash && location.hash.indexOf('#kc-mt-album-') === 0) {
      var hashEl = document.getElementById(location.hash.slice(1));
      if (hashEl && hashEl.getAttribute('data-idx') != null) {
        var hashIdx = +hashEl.getAttribute('data-idx');
        var goHash = function () { setActive(hashIdx); centerAlbum(hashEl, false); };
        requestAnimationFrame(goHash);
        /* Re-center once images/fonts/the sticky header have settled — the first frame
           is usually pre-layout-shift, which left the album off-center on a hash load. */
        if (document.readyState !== 'complete') {
          window.addEventListener('load', function () { requestAnimationFrame(goHash); }, { once: true });
        }
        setTimeout(goHash, 400);
      }
    }
  }
})();

/*-------- KC ALBUM DETAIL (sections/kc-album-detail.liquid + split sibling sections) --------
   The album page is a hero/nav frame (KC - Album detail) plus sibling sections:
   KC - Album Tracklist, KC - Album Media, KC - Album About, the Shop product-list,
   and KC - Albums (more music). This drives: the sticky scrollspy nav (built by
   DISCOVERING the sibling sections, which expose [data-kc-ad-section]), the hero
   cover tilt, the media gallery -> shared lightbox ([data-kc-ad-media]), and the
   More module's era rail ([data-kc-ad-more]). */
(function () {
  function escHtml(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function escAttr(s) { return escHtml(s).replace(/"/g, '&quot;'); }
  function cssUrl(u) { return "'" + String(u).replace(/\\/g, '\\\\').replace(/'/g, "\\'") + "'"; }

  /* Media gallery + More rail are their own sections now, so wire them off their
     own markers rather than the album-detail root. */
  initMedia();
  initMore();
  initTrackVideos();
  initCoverModal();

  var roots = document.querySelectorAll('[data-kc-album-detail]');
  [].forEach.call(roots, function (root) {
    if (root.dataset.kcAdInit) return;
    root.dataset.kcAdInit = '1';
    try { init(root); } catch (e) { /* leave server-rendered content in place */ }
  });

  /* Hide the Shop product-list section when the album has no related products. */
  if (roots[0] && roots[0].getAttribute('data-kc-ad-has-shop') === 'false') {
    var emptyShop = document.querySelector('[data-testid="product-list"]');
    if (emptyShop) {
      var emptyShopSection = emptyShop.closest('.shopify-section');
      if (emptyShopSection) emptyShopSection.style.display = 'none';
    }
  }

  function init(root) {
    var adNav = root.querySelector('.kc-album-detail__nav');

    /* Build the nav by discovering the sibling content sections in page order.
       Each exposes [data-kc-ad-section]="<label>"; the Shop is the product-list
       section (wrapped in #kc-ad-shop so it keeps its own shopify-section id). */
    if (adNav) {
      var addNavItem = function (targetId, label) {
        if (!targetId || !label || !document.getElementById(targetId)) return;
        if (adNav.querySelector('[data-target="' + targetId + '"]')) return;
        var a = document.createElement('a');
        a.className = 'kc-album-detail__navitem';
        a.href = '#' + targetId;
        a.setAttribute('data-target', targetId);
        a.textContent = label;
        adNav.appendChild(a);
      };
      var hasShop = root.getAttribute('data-kc-ad-has-shop') !== 'false';
      var targets = [].slice.call(document.querySelectorAll('[data-kc-ad-section], [data-testid="product-list"]'));
      targets.forEach(function (el) {
        if (el.getAttribute('data-testid') === 'product-list') {
          if (!hasShop) return;
          var shopSec = el.closest('.shopify-section');
          if (shopSec && !document.getElementById('kc-ad-shop')) {
            /* Wrap the Shop section in an anchor div rather than overwriting the
               section's own id, so it keeps its conventional shopify-section id.
               Both the nav anchor and the hero "Shop" button (href="#kc-ad-shop")
               land on this wrapper, offset below the pinned nav. */
            var shopAnchor = document.createElement('div');
            shopAnchor.id = 'kc-ad-shop';
            shopAnchor.style.scrollMarginTop = 'calc(var(--kc-topbar-h, 0px) + var(--header-height, 60px) + 72px)';
            shopSec.parentNode.insertBefore(shopAnchor, shopSec);
            shopAnchor.appendChild(shopSec);
          }
          var sh = document.querySelector('#kc-ad-shop h2');
          addNavItem('kc-ad-shop', (sh && sh.textContent.trim()) || 'Shop');
        } else {
          var label = el.getAttribute('data-kc-ad-section');
          if (!label) {
            var h = el.querySelector('.kc-album-detail__h');
            label = (h && h.textContent.trim()) || el.id;
          }
          addNavItem(el.id, label);
        }
      });
      /* If nothing was discovered (e.g. a bare album), don't leave an empty bar. */
      if (!adNav.querySelector('.kc-album-detail__navitem')) adNav.style.display = 'none';
    }

    /* Scrollspy nav — targets live in the sibling sections. */
    var navItems = [].slice.call(adNav ? adNav.querySelectorAll('.kc-album-detail__navitem') : []);
    if (navItems.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            navItems.forEach(function (n) { n.classList.toggle('is-on', n.getAttribute('data-target') === en.target.id); });
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
      navItems.forEach(function (n) {
        var el = document.getElementById(n.getAttribute('data-target'));
        if (el) io.observe(el);
        n.addEventListener('click', function (e) {
          e.preventDefault();
          var target = document.getElementById(n.getAttribute('data-target'));
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    /* Pin the nav under the site header and keep it pinned across the Shop and
       More music sections below it — position:sticky can't cross sibling
       Shopify sections, so once the nav reaches the header we switch it to
       position:fixed. A spacer preserves its space so content doesn't jump.
       The top offset follows whichever chrome sits lowest (the always-fixed
       topbar and/or the reveal-on-scroll header). */
    var siteHeader = document.getElementById('header-component');
    var topBar = document.querySelector('.kc-topbar');
    if (adNav) {
      var navSpacer = document.createElement('div');
      navSpacer.className = 'kc-album-detail__nav-spacer';
      adNav.parentNode.insertBefore(navSpacer, adNav);
      var navPinned = false;
      var navRaf = null;
      var syncNav = function () {
        navRaf = null;
        var t = 0;
        if (topBar) t = Math.max(t, topBar.getBoundingClientRect().bottom);
        if (siteHeader) t = Math.max(t, siteHeader.getBoundingClientRect().bottom);
        t = Math.max(0, t);
        adNav.style.top = t + 'px';
        if (!navPinned && navSpacer.getBoundingClientRect().top <= t) {
          navSpacer.style.height = adNav.offsetHeight + 'px';
          adNav.classList.add('is-pinned');
          navPinned = true;
        } else if (navPinned && navSpacer.getBoundingClientRect().top > t) {
          adNav.classList.remove('is-pinned');
          navSpacer.style.height = '';
          navPinned = false;
        }
      };
      var onNavScroll = function () { if (!navRaf) navRaf = requestAnimationFrame(syncNav); };
      syncNav();
      window.addEventListener('scroll', onNavScroll, { passive: true });
      window.addEventListener('resize', onNavScroll, { passive: true });
    }

    /* Hero cover tilt (pointer devices only) */
    var cover = root.querySelector('.kc-album-detail__cover');
    if (cover && window.matchMedia && window.matchMedia('(hover: hover)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cover.addEventListener('mousemove', function (e) {
        var r = cover.getBoundingClientRect();
        var px = ((e.clientX - r.left) / r.width - 0.5) * 2, py = ((e.clientY - r.top) / r.height - 0.5) * 2;
        cover.style.transform = 'rotateY(' + (px * 9).toFixed(1) + 'deg) rotateX(' + (-py * 9).toFixed(1) + 'deg) scale(1.04)';
      });
      cover.addEventListener('mouseleave', function () { cover.style.transform = ''; });
    }

  }

  /* Media gallery (KC - Album Media): on-page tabs filter the tiles; clicking a
     tile opens the shared lightbox (top of this file), which carries its own
     All/Videos/Photos tabs, inline YouTube/<video>, prev/next, and Esc. */
  function initMedia() {
    var mediaSec = document.querySelector('[data-kc-ad-media]');
    if (!mediaSec) return;
    var tiles = [].slice.call(mediaSec.querySelectorAll('.kc-album-detail__tile'));
    if (!tiles.length) return;
    var tabBtns = [].slice.call(mediaSec.querySelectorAll('[data-kc-ad-tab]'));
    var activeTab = 'all';
    var matches = function (t) { return activeTab === 'all' || t.getAttribute('data-kind') === activeTab; };
    var applyTab = function () {
      tiles.forEach(function (t) { t.classList.toggle('is-hidden', !matches(t)); });
      tabBtns.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-kc-ad-tab') === activeTab); });
    };
    tabBtns.forEach(function (b) { b.addEventListener('click', function () { activeTab = b.getAttribute('data-kc-ad-tab'); applyTab(); }); });

    var albumTitle = mediaSec.getAttribute('data-kc-ad-album-title') || '';
    var items = tiles.map(function (t) {
      return {
        kind: t.getAttribute('data-kind') === 'p' ? 'p' : 'v',
        label: t.getAttribute('data-label') || '',
        src: t.getAttribute('data-src') || '',
        thumb: t.getAttribute('data-thumb') || ''
      };
    });
    tiles.forEach(function (t, i) {
      t.addEventListener('click', function () {
        window.KCMediaLightbox.open(items, i, { title: albumTitle, tabs: true });
      });
    });
  }

  /* Tracklist rows that matched a music video get a mini thumbnail; clicking it opens
     that one video in the shared lightbox. */
  function initTrackVideos() {
    var btns = [].slice.call(document.querySelectorAll('.kc-album-detail__track-video'));
    if (!btns.length || !window.KCMediaLightbox) return;
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var item = {
          kind: 'v',
          label: b.getAttribute('data-label') || '',
          src: b.getAttribute('data-src') || '',
          thumb: b.getAttribute('data-thumb') || ''
        };
        if (item.src) window.KCMediaLightbox.open([item], 0, { title: item.label });
      });
    });
  }

  /* Clicking the hero album cover opens it (full-res) in the shared lightbox. */
  function initCoverModal() {
    var cover = document.querySelector('[data-kc-ad-cover]');
    if (!cover || !window.KCMediaLightbox) return;
    var open = function () {
      var src = cover.getAttribute('data-src');
      if (!src) return;
      var label = cover.getAttribute('data-label') || '';
      var items = [{ kind: 'p', src: src, thumb: cover.getAttribute('data-thumb') || src, label: label }];
      var discSrc = cover.getAttribute('data-disc-src');
      if (discSrc) {
        items.push({ kind: 'p', src: discSrc, thumb: cover.getAttribute('data-disc-thumb') || discSrc, label: label + ' vinyl' });
      }
      window.KCMediaLightbox.open(items, 0, { title: label, caption: false });
    };
    cover.addEventListener('click', open);
    cover.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
  }

  /* More music (KC - Albums): era-scoped sibling rail built from the emitted JSON. */
  function initMore() {
    var moreSec = document.querySelector('[data-kc-ad-more]');
    if (!moreSec) return;
    var dataEl = moreSec.querySelector('[data-kc-ad-data]');
    var railEl = moreSec.querySelector('[data-kc-ad-rail]');
    var pagerEl = moreSec.querySelector('[data-kc-ad-pager]');
    if (!dataEl || !(railEl || pagerEl)) return;
    var data = null;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { data = null; }
    if (!data || !data.albums || !data.albums.length) return;
    var albums = data.albums.slice();
    albums.forEach(function (a) {
      a.year = a.year == null ? null : parseInt(a.year, 10);
      a.ts = a.ts == null ? null : parseInt(a.ts, 10);
    });
    albums.sort(function (a, b) {
      var at = a.ts == null ? (a.year == null ? -Infinity : a.year * 31557600) : a.ts;
      var bt = b.ts == null ? (b.year == null ? -Infinity : b.year * 31557600) : b.ts;
      return bt - at;
    });
    var artStyle = function (a) { return a.cover ? 'background-image:url(' + cssUrl(a.cover) + ');' : ''; };
    if (railEl) {
      var curTs = data.currentTs == null ? null : parseInt(data.currentTs, 10);
      /* Pick the four albums nearest by release date to the current one, then show
         them newest-first. With no release date, fall back to the newest others
         (albums is already sorted newest-first above). */
      var pool = albums.filter(function (a) { return a.id !== data.currentId; });
      if (curTs != null) {
        pool.sort(function (a, b) {
          var ad = a.ts == null ? Infinity : Math.abs(a.ts - curTs);
          var bd = b.ts == null ? Infinity : Math.abs(b.ts - curTs);
          return ad - bd;
        });
      }
      var others = pool.slice(0, 4).sort(function (a, b) {
        var at = a.ts == null ? (a.year == null ? -Infinity : a.year * 31557600) : a.ts;
        var bt = b.ts == null ? (b.year == null ? -Infinity : b.year * 31557600) : b.ts;
        return bt - at;
      });
      railEl.innerHTML = others.map(function (a) {
        /* "Releases" (future) / "Released" (past) before the year, matching the timeline + hero. */
        var isFuture = a.ts != null ? (a.ts * 1000 > Date.now()) : (a.year != null && a.year > new Date().getFullYear());
        var relVerb = isFuture ? 'Releases ' : 'Released ';
        var when = a.date || (a.year ? String(a.year) : '');
        return '<a class="kc-album-detail__rail-card" href="' + escAttr(a.url || '#') + '">' +
          '<span class="kc-album-detail__rail-art" style="' + artStyle(a) + '">' + (a.cover ? '' : '<span class="kc-album-detail__rail-title">' + escHtml(a.title) + '</span>') + '</span>' +
          '<span class="kc-album-detail__rail-meta"><strong>' + escHtml(a.title) + '</strong><span>' + escHtml(a.type) + (when ? ' · ' + relVerb + escHtml(when) : '') + '</span></span></a>';
      }).join('');
    }
    /* The rail already lists the nearest other albums, so the Newer/Older pager is
       redundant — hide it. */
    if (pagerEl) pagerEl.style.display = 'none';
  }
})();

/*-------- SOCIAL PULSE: rotating spotlight, like-count ticker, post modal --------*/
(function () {
  var sections = document.querySelectorAll('.kc-social-pulse');
  if (!sections.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROTATE_MS = 7000;

  function parseLikes(raw) {
    if (raw == null) return null;
    var s = String(raw).trim();
    if (!s) return null;
    var m = s.match(/^([\d.,]+)\s*([KkMm])?/);
    if (!m) return null;
    var num = parseFloat(m[1].replace(/,/g, ''));
    if (isNaN(num)) return null;
    var suf = m[2] ? m[2].toUpperCase() : '';
    if (suf === 'K') num *= 1000;
    if (suf === 'M') num *= 1000000;
    return Math.round(num);
  }
  function formatLikes(n) {
    try { return n.toLocaleString('en-US'); } catch (e) { return String(n); }
  }
  // Deterministic 0..1 fraction from a string, so each post's derived numbers are
  // stable across opens (not random each time).
  function seedFrac(str, salt) {
    str = String(str || '') + (salt || '');
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return (h >>> 0) / 4294967295;
  }
  // The IG feed only provides like counts today. Show real comment/view counts if
  // the feed ever adds them; otherwise derive believable demo figures from likes
  // (comments ~1-3% of likes; video views a large multiple, much bigger than likes).
  function deriveComments(likes, seed) {
    if (likes == null) return null;
    return Math.max(1, Math.round(likes * (0.01 + seedFrac(seed, 'c') * 0.02)));
  }
  function deriveViews(likes, seed) {
    if (likes == null) return null;
    return Math.round(likes * (8 + seedFrac(seed, 'v') * 14));
  }
  function countUp(el, target) {
    if (target == null) return;
    if (reduceMotion) { el.textContent = formatLikes(target); return; }
    var start = null, dur = 900;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatLikes(Math.round(target * eased));
      if (t < 1) requestAnimationFrame(step); else el.textContent = formatLikes(target);
    }
    requestAnimationFrame(step);
  }

  function pulse(item) {
    var num = item.querySelector('.kc-social-pulse__likes-num');
    var pill = item.querySelector('.kc-social-pulse__likes');
    if (pill) { pill.classList.remove('is-bounce'); void pill.offsetWidth; pill.classList.add('is-bounce'); }
    if (num && num.__target != null) {
      // Simulate fresh likes arriving since the tile was last featured, so the
      // numbers visibly grow each rotation — the feed reads as live/changing.
      if (!reduceMotion) num.__target += Math.floor(Math.random() * 11) + 2;
      countUp(num, num.__target);
    }
  }

  // ---- live Instagram feed (demo): build tiles from the feed service ----
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function buildTile(post) {
    var isVideo = String(post.type || '').toLowerCase() === 'video';
    var img = post.image || '';
    var link = post.permalink || '';
    var likes = (post.likes != null && post.likes !== '') ? String(post.likes) : '';
    var caption = post.caption || '';

    var el = document.createElement(link ? 'a' : 'button');
    el.className = 'kc-social-pulse__item';
    if (link) { el.href = link; el.target = '_blank'; el.rel = 'noopener'; }
    else { el.type = 'button'; }
    el.setAttribute('data-sp-open', '');
    el.setAttribute('data-sp-image', img);
    el.setAttribute('data-sp-likes', likes);
    el.setAttribute('data-sp-caption', caption);
    el.setAttribute('data-sp-link', link);
    if (isVideo) el.setAttribute('data-sp-type', 'video');
    // Real counts from the feed take precedence (left empty here if absent, then
    // derived from likes at open time so feed + manual tiles behave the same).
    var realComments = post.comments != null ? post.comments : (post.comment_count != null ? post.comment_count : post.comments_count);
    var realViews = post.views != null ? post.views : (post.view_count != null ? post.view_count : (post.video_views != null ? post.video_views : post.play_count));
    if (realComments != null && realComments !== '') el.setAttribute('data-sp-comments', realComments);
    if (realViews != null && realViews !== '') el.setAttribute('data-sp-views', realViews);
    // Background is applied lazily (see lazyBackgrounds) from data-sp-image.

    var html = '';
    if (likes) {
      html += '<span class="kc-social-pulse__likes" title="' + esc(likes) + ' likes on Instagram" aria-hidden="true">'
            +   '<span class="kc-social-pulse__likes-num" data-sp-likes-num="' + esc(likes) + '">' + esc(likes) + '</span> Likes'
            + '</span>';
    }
    html += '<span class="kc-social-pulse__badge" title="View on Instagram" aria-hidden="true">'
          +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">'
          +     '<rect x="3" y="3" width="18" height="18" rx="5"></rect>'
          +     '<circle cx="12" cy="12" r="4"></circle>'
          +     '<circle cx="17.3" cy="6.7" r="1" fill="currentColor"></circle>'
          +   '</svg>'
          + '</span>';
    if (isVideo) {
      html += '<span class="kc-social-pulse__play" aria-hidden="true">'
            +   '<span class="kc-social-pulse__play-circle">'
            +     '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"></path></svg>'
            +   '</span>'
            + '</span>';
    }
    if (caption) {
      html += '<span class="kc-social-pulse__caption"><span>' + esc(caption) + '</span></span>';
    }
    el.innerHTML = html;
    return el;
  }
  function loadFeed(section) {
    var url = section.getAttribute('data-sp-feed-url');
    if (!url) return Promise.resolve();
    var count = parseInt(section.getAttribute('data-sp-feed-count'), 10) || 12;
    var grid = section.querySelector('.kc-social-pulse__grid');
    if (!grid) return Promise.resolve();
    return fetch(url, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var posts = (data && data.posts) || [];
        if (!posts.length) return; // keep the manual fallback tiles on empty/error
        grid.innerHTML = '';
        posts.slice(0, count).forEach(function (p) { grid.appendChild(buildTile(p)); });
      })
      .catch(function () { /* network error -> leave the manual fallback tiles in place */ });
  }

  var rotators = [];
  function pauseAll(p) { rotators.forEach(function (r) { r.pause(p); }); }

  // Defer each tile's photo (often a full-res Instagram JPEG) until it nears the
  // viewport. This section sits far down the page, so eager-loading every tile
  // stole bandwidth from above-the-fold content during the initial load.
  function applyBg(el) {
    var url = el.getAttribute('data-sp-image');
    if (url) el.style.setProperty('--kc-social-pulse-image', "url('" + url.replace(/'/g, '%27') + "')");
    el.setAttribute('data-sp-loaded', '');
  }
  function lazyBackgrounds() {
    var items = document.querySelectorAll('.kc-social-pulse__item[data-sp-image]:not([data-sp-loaded])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, applyBg);
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { applyBg(e.target); obs.unobserve(e.target); }
      });
    }, { rootMargin: '600px 0px' });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  function initGrids() {
    lazyBackgrounds(); // covers both manual tiles and any feed-built tiles
    // Pre-format every visible like number, remember its numeric target.
    Array.prototype.forEach.call(document.querySelectorAll('.kc-social-pulse__likes-num'), function (el) {
      var n = parseLikes(el.getAttribute('data-sp-likes-num'));
      el.__target = n;
      if (n != null) el.textContent = formatLikes(n);
    });

    Array.prototype.forEach.call(sections, function (section) {
      var items = Array.prototype.slice.call(section.querySelectorAll('.kc-social-pulse__item'));
      if (!items.length) return;
      var idx = -1, timer = null, paused = false, started = false;
      var grid = section.querySelector('.kc-social-pulse__grid');

      // Countdown bar on the active (featured) tile, synced to the rotate interval.
      section.style.setProperty('--kc-sp-rotate', ROTATE_MS + 'ms');
      items.forEach(function (el) {
        if (!el.querySelector('.kc-social-pulse__timer')) {
          var bar = document.createElement('span');
          bar.className = 'kc-social-pulse__timer';
          bar.setAttribute('aria-hidden', 'true');
          el.appendChild(bar);
        }
      });

      function isDesktopShuffle() {
        return grid && !reduceMotion && window.matchMedia('(min-width: 990px)').matches;
      }

      function clear() { items.forEach(function (i) { i.classList.remove('is-active'); }); }
      function setActive(next) {
        clear();
        idx = (next == null) ? (idx + 1) % items.length : next;
        items[idx].classList.add('is-active');
        pulse(items[idx]);
      }

      // Desktop: reshuffle the WHOLE grid each tick so every tile glides to a new
      // cell, not just the spotlight. FLIP technique: measure -> reorder (dense flow
      // repacks all the squares around the fixed-center feature) -> animate from the
      // old position/size to the new one. Mobile keeps the simple spotlight swap.
      function tick() {
        if (!isDesktopShuffle()) { setActive(); return; }

        var firsts = items.map(function (el) { return el.getBoundingClientRect(); });
        setActive();
        grid.appendChild(grid.firstElementChild); // rotate order -> squares repack

        items.forEach(function (el, i) {
          var last = el.getBoundingClientRect();
          var dx = firsts[i].left - last.left;
          var dy = firsts[i].top - last.top;
          var sx = last.width ? firsts[i].width / last.width : 1;
          var sy = last.height ? firsts[i].height / last.height : 1;
          el.style.transition = 'none';
          el.style.transformOrigin = 'top left';
          el.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')';
        });

        requestAnimationFrame(function () {
          items.forEach(function (el) {
            el.style.transition = 'transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1)';
            el.style.transform = '';
          });
        });
      }

      function start() {
        if (started) return;
        started = true;
        setActive(0); // feature the first tile immediately (no shuffle on first paint)
        if (reduceMotion) return; // ...but don't auto-rotate when reduced motion is preferred
        timer = setInterval(function () { if (!paused) tick(); }, ROTATE_MS);
      }
      // No hover pause — the feed keeps rotating while you browse, so it stays
      // lively. (Opening the post modal still pauses it via pauseAll below.)
      rotators.push({ pause: function (p) { paused = p; } });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (e) { if (e.isIntersecting) { start(); obs.disconnect(); } });
        }, { threshold: 0.2 });
        io.observe(section);
      } else {
        start();
      }
    });
  }

  // Load any live feeds first, then wire up the grids (falls back to manual tiles).
  var feedJobs = [];
  Array.prototype.forEach.call(sections, function (section) {
    if (section.getAttribute('data-sp-feed-url')) feedJobs.push(loadFeed(section));
  });
  if (feedJobs.length) Promise.all(feedJobs).then(initGrids); else initGrids();

  // ---- post modal ----
  var modal = document.querySelector('[data-sp-modal]');
  if (modal) {
    if (modal.parentNode !== document.body) document.body.appendChild(modal); // escape ancestor stacking contexts
    var imgEl = modal.querySelector('[data-sp-modal-img]');
    var likesEl = modal.querySelector('[data-sp-modal-likes]');
    var likesWrap = modal.querySelector('[data-sp-modal-likes-wrap]');
    var commentsEl = modal.querySelector('[data-sp-modal-comments]');
    var commentsWrap = modal.querySelector('[data-sp-modal-comments-wrap]');
    var viewsEl = modal.querySelector('[data-sp-modal-views]');
    var viewsWrap = modal.querySelector('[data-sp-modal-views-wrap]');
    var capEl = modal.querySelector('[data-sp-modal-caption]');
    var linkEl = modal.querySelector('[data-sp-modal-link]');
    var closeBtn = modal.querySelector('.kc-social-pulse-modal__close');
    var lastFocus = null;

    function openModal(trigger) {
      lastFocus = trigger;
      pauseAll(true);
      var img = trigger.getAttribute('data-sp-image') || '';
      var caption = trigger.getAttribute('data-sp-caption') || '';
      var link = trigger.getAttribute('data-sp-link') || '';
      var likes = parseLikes(trigger.getAttribute('data-sp-likes'));
      var seed = link || caption;
      var isVideo = (trigger.getAttribute('data-sp-type') || '').toLowerCase() === 'video'
        || /\/reel\//.test(link)
        || !!(trigger.querySelector && trigger.querySelector('.kc-social-pulse__play'));
      // Real counts win; otherwise derive from likes. Views only apply to videos.
      var commentsAttr = parseLikes(trigger.getAttribute('data-sp-comments'));
      var viewsAttr = parseLikes(trigger.getAttribute('data-sp-views'));
      var comments = commentsAttr != null ? commentsAttr : deriveComments(likes, seed);
      var views = viewsAttr != null ? viewsAttr : (isVideo ? deriveViews(likes, seed) : null);
      // Videos show view count (not likes); photos show like count. Comments on both.
      var showLikes = likes != null && !isVideo;
      var showViews = views != null && isVideo;
      var showComments = comments != null;
      if (imgEl) { imgEl.src = img; imgEl.alt = caption || 'Instagram post'; }
      if (capEl) capEl.textContent = caption;
      if (likesWrap) likesWrap.style.display = showLikes ? '' : 'none';
      if (commentsWrap) commentsWrap.style.display = showComments ? '' : 'none';
      if (viewsWrap) viewsWrap.style.display = showViews ? '' : 'none';
      if (linkEl) {
        if (link) { linkEl.href = link; linkEl.style.display = ''; }
        else { linkEl.style.display = 'none'; }
      }
      modal.hidden = false;
      document.body.classList.add('kc-sp-modal-open');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      if (showLikes && likesEl) { likesEl.textContent = '0'; countUp(likesEl, likes); }
      if (showComments && commentsEl) { commentsEl.textContent = '0'; countUp(commentsEl, comments); }
      if (showViews && viewsEl) { viewsEl.textContent = '0'; countUp(viewsEl, views); }
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('kc-sp-modal-open');
      pauseAll(false);
      setTimeout(function () { modal.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-sp-open]');
      if (trigger) { e.preventDefault(); openModal(trigger); return; }
      if (e.target.closest && e.target.closest('[data-sp-close]')) { e.preventDefault(); closeModal(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && !modal.hidden) closeModal();
    });
  }
})();

/*-------- News year slider: slide through years, grid shuffles/rebuilds --------*/
(function () {
  var sections = document.querySelectorAll('.blog-posts');
  if (!sections.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(sections, function (section) {
    var grid = section.querySelector('.blog-posts-container');
    if (!grid) return;
    // Full year range comes from the existing pill nav (built from ALL the blog's
    // year tags), so the slider reaches back to the very first article — even though
    // only ~12 articles render up front. Each year's posts then load on demand.
    var pillNav = section.querySelector('.kc-year-filter');
    if (!pillNav) return;
    var pillEls = Array.prototype.slice.call(pillNav.querySelectorAll('.kc-year-pill'));
    if (pillEls.length < 2) return;

    var allStop = null, yearStops = [];
    pillEls.forEach(function (a) {
      var label = a.textContent.trim();
      var stop = { label: label, year: /^\d{4}$/.test(label) ? label : 'all', url: a.getAttribute('href') };
      if (stop.year === 'all') allStop = stop; else yearStops.push(stop);
    });
    if (!allStop) allStop = { label: 'All', year: 'all', url: pillEls[0].getAttribute('href') };
    yearStops.sort(function (a, b) { return b.year.localeCompare(a.year); }); // newest -> oldest (All, 2026, ... 2015)
    var stops = [allStop].concat(yearStops);
    if (stops.length < 2) return;

    // Initially rendered cards = the "All" set. Per-year sets are fetched lazily.
    var initialCards = Array.prototype.slice.call(grid.querySelectorAll('.blog-post-item'));
    initialCards.forEach(function (el) { el.__origHoriz = el.classList.contains('blog-post-item--horizontal'); });
    var yearSets = {};
    var fetching = {};

    // Build the slider UI.
    var wrap = document.createElement('div');
    wrap.className = 'kc-year-slider';
    wrap.innerHTML =
      '<div class="kc-year-slider__readout"><span class="kc-year-slider__label">All Years</span></div>' +
      '<input class="kc-year-slider__range" type="range" min="0" max="' + (stops.length - 1) + '" step="any" value="0" aria-label="Filter news by year">' +
      '<div class="kc-year-slider__ticks">' +
        stops.map(function (s, i) {
          return '<button type="button" class="kc-year-slider__tick" data-stop="' + i + '">' + s.label + '</button>';
        }).join('') +
      '</div>';

    pillNav.style.display = 'none'; // keep in the DOM as a no-JS fallback
    grid.parentNode.insertBefore(wrap, grid);

    // ---- "[Year] in Photos" strip: tour/event shots from the photo_category metaobjects ----
    function spEsc(s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    var photosByYear = {};
    var TOUR_PHOTOS_URL = 'https://kc-cloudflare-feed.sparkart.workers.dev/photos.json';
    fetch(TOUR_PHOTOS_URL, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        ((data && data.photos) || []).forEach(function (p) {
          if (!p || p.year == null) return;
          var y = String(p.year);
          (photosByYear[y] = photosByYear[y] || []).push(p);
        });
        // Data arrives async — if a year is already selected, fill its strip now.
        var i = parseInt(range.value, 10);
        if (stops[i] && stops[i].year !== 'all') renderStrip(stops[i].year);
      })
      .catch(function () { /* feed unreachable -> strip just stays hidden */ });

    var strip = document.createElement('div');
    strip.className = 'kc-tour-photos';
    strip.hidden = true;
    wrap.parentNode.insertBefore(strip, wrap.nextSibling); // sits between the slider and the grid

    var currentStripYear = null;

    // Navy circular scroll arrow for the strips, matching the Shop carousel.
    var stripArrowSvg = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>';
    var photoArrowUpdate = null, videoArrowUpdate = null;
    // Wire a strip's prev/next arrows like the /collections carousel: prev hides
    // at the start, next hides at the end, both hide when the row doesn't
    // overflow. Returns an updater so one resize listener can refresh every strip.
    function setupStripArrow(container, rowSel, prevSel, nextSel) {
      var row = container.querySelector(rowSel);
      var prev = container.querySelector(prevSel);
      var next = container.querySelector(nextSel);
      if (!row) return null;
      function update() {
        var overflows = row.scrollWidth - row.clientWidth > 4;
        var atStart = row.scrollLeft <= 4;
        var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
        if (prev) prev.hidden = !overflows || atStart;
        if (next) next.hidden = !overflows || atEnd;
      }
      if (prev) prev.addEventListener('click', function () {
        row.scrollBy({ left: -Math.round(row.clientWidth * 0.85), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        row.scrollBy({ left: Math.round(row.clientWidth * 0.85), behavior: 'smooth' });
      });
      row.addEventListener('scroll', update, { passive: true });
      update();
      return update;
    }
    window.addEventListener('resize', function () {
      if (photoArrowUpdate) photoArrowUpdate();
      if (videoArrowUpdate) videoArrowUpdate();
    });

    function renderStrip(year) {
      var list = (year && year !== 'all') ? photosByYear[year] : null;
      if (!list || !list.length) { strip.hidden = true; strip.innerHTML = ''; currentStripYear = null; return; }
      currentStripYear = year;
      var pics = list.slice(0, 14);
      var cats = pics.map(function (p) { return p.cat; }).filter(function (v, i, a) { return v && a.indexOf(v) === i; });
      strip.innerHTML =
        '<div class="kc-tour-photos__head"><span class="kc-tour-photos__year">' + spEsc(year) + '</span> in Photos' +
          (cats.length ? '<span class="kc-tour-photos__cats">' + spEsc(cats.join('  ·  ')) + '</span>' : '') +
        '</div>' +
        '<div class="kc-tour-photos__viewport">' +
          '<div class="kc-tour-photos__row">' +
            pics.map(function (p, i) {
              return '<figure class="kc-tour-photos__item" data-idx="' + i + '" tabindex="0" role="button" style="animation-delay:' + (i * 45) + 'ms">' +
                       '<img src="' + spEsc(p.img) + '" alt="" loading="lazy">' +
                       (p.cat ? '<figcaption>' + spEsc(p.cat) + '</figcaption>' : '') +
                     '</figure>';
            }).join('') +
          '</div>' +
          '<button class="kc-tour-photos__arrow kc-tour-photos__arrow--prev" type="button" aria-label="Scroll back" hidden>' + stripArrowSvg + '</button>' +
          '<button class="kc-tour-photos__arrow kc-tour-photos__arrow--next" type="button" aria-label="Scroll for more photos" hidden>' + stripArrowSvg + '</button>' +
        '</div>';
      strip.hidden = false;
      photoArrowUpdate = setupStripArrow(strip, '.kc-tour-photos__row', '.kc-tour-photos__arrow--prev', '.kc-tour-photos__arrow--next');
    }

    // ---- lightbox: click a strip photo -> large view, arrow/swipe through the whole collection ----
    function fullSizeUrl(img) {
      // swap the square face-crop transform for a no-crop fit so the lightbox shows the whole photo
      return String(img || '').replace(/\/image\/fetch\/[^/]+\//, '/image/fetch/c_limit,w_1600,f_auto,q_auto/');
    }
    var lb = document.createElement('div');
    lb.className = 'kc-lightbox';
    lb.hidden = true;
    // Same arrow icon (icon-arrow.svg) the /collections carousel uses, so every arrow matches.
    var lbCaret = '<svg class="kc-lightbox__caret" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" vector-effect="non-scaling-stroke" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>';
    lb.innerHTML =
      '<button class="kc-lightbox__close" type="button" aria-label="Close">×</button>' +
      '<button class="kc-lightbox__nav kc-lightbox__nav--prev" type="button" aria-label="Previous">' + lbCaret + '</button>' +
      '<button class="kc-lightbox__nav kc-lightbox__nav--next" type="button" aria-label="Next">' + lbCaret + '</button>' +
      '<figure class="kc-lightbox__stage"><img class="kc-lightbox__img" alt=""><figcaption class="kc-lightbox__cap"></figcaption></figure>' +
      '<div class="kc-lightbox__counter"></div>';
    document.body.appendChild(lb);
    var lbImg = lb.querySelector('.kc-lightbox__img');
    var lbCap = lb.querySelector('.kc-lightbox__cap');
    var lbCount = lb.querySelector('.kc-lightbox__counter');
    var lbList = [], lbIdx = 0;

    function lbRender() {
      var p = lbList[lbIdx];
      if (!p) return;
      lbImg.src = fullSizeUrl(p.img);
      lbImg.alt = p.cat || '';
      lbCap.textContent = (p.cat || '') + (p.caption ? '  ·  ' + p.caption : '');
      lbCount.textContent = (lbIdx + 1) + ' / ' + lbList.length;
    }
    function lbOpen(list, idx) {
      if (!list || !list.length) return;
      lbList = list;
      lbIdx = Math.max(0, Math.min(list.length - 1, idx || 0));
      lbRender();
      lb.hidden = false;
      document.body.classList.add('kc-lightbox-open');
    }
    function lbClose() { lb.hidden = true; document.body.classList.remove('kc-lightbox-open'); }
    function lbGo(d) { if (!lbList.length) return; lbIdx = (lbIdx + d + lbList.length) % lbList.length; lbRender(); }

    lb.querySelector('.kc-lightbox__close').addEventListener('click', lbClose);
    lb.querySelector('.kc-lightbox__nav--prev').addEventListener('click', function (e) { e.stopPropagation(); lbGo(-1); });
    lb.querySelector('.kc-lightbox__nav--next').addEventListener('click', function (e) { e.stopPropagation(); lbGo(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); }); // click backdrop to close
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbGo(-1);
      else if (e.key === 'ArrowRight') lbGo(1);
    });
    var lbTouchX = null;
    lb.addEventListener('touchstart', function (e) { lbTouchX = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (lbTouchX == null) return;
      var dx = e.changedTouches[0].clientX - lbTouchX;
      if (Math.abs(dx) > 40) lbGo(dx < 0 ? 1 : -1);
      lbTouchX = null;
    }, { passive: true });

    // Open from a strip photo. The carousel walks the FULL year's collection (not just the 14 shown).
    function openFromFigure(fig) {
      if (!fig || !currentStripYear) return;
      lbOpen(photosByYear[currentStripYear] || [], parseInt(fig.getAttribute('data-idx'), 10) || 0);
    }
    strip.addEventListener('click', function (e) {
      openFromFigure(e.target.closest && e.target.closest('.kc-tour-photos__item'));
    });
    strip.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var fig = e.target.closest && e.target.closest('.kc-tour-photos__item');
      if (fig) { e.preventDefault(); openFromFigure(fig); }
    });

    // ---- "[Year] in Videos" strip: YouTube videos for that year, click -> inline player carousel ----
    var videosByYear = {};
    var TOUR_VIDEOS_URL = 'https://kc-cloudflare-feed.sparkart.workers.dev/videos.json';
    fetch(TOUR_VIDEOS_URL, { mode: 'cors' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        ((data && data.videos) || []).forEach(function (v) {
          if (!v || v.year == null) return;
          var y = String(v.year);
          (videosByYear[y] = videosByYear[y] || []).push(v);
        });
        var i = parseInt(range.value, 10);
        if (stops[i] && stops[i].year !== 'all') renderVideoStrip(stops[i].year);
      })
      .catch(function () { /* feed unreachable -> strip just stays hidden */ });

    var vstrip = document.createElement('div');
    vstrip.className = 'kc-tour-videos';
    vstrip.hidden = true;
    strip.parentNode.insertBefore(vstrip, strip.nextSibling); // sits right under the photo strip

    var currentVideoYear = null;

    function renderVideoStrip(year) {
      var list = (year && year !== 'all') ? videosByYear[year] : null;
      if (!list || !list.length) { vstrip.hidden = true; vstrip.innerHTML = ''; currentVideoYear = null; return; }
      currentVideoYear = year;
      var vids = list.slice(0, 14);
      var cats = vids.map(function (v) { return v.cat; }).filter(function (v, i, a) { return v && a.indexOf(v) === i; });
      vstrip.innerHTML =
        '<div class="kc-tour-videos__head"><span class="kc-tour-videos__year">' + spEsc(year) + '</span> in Videos' +
          (cats.length ? '<span class="kc-tour-videos__cats">' + spEsc(cats.join('  ·  ')) + '</span>' : '') +
        '</div>' +
        '<div class="kc-tour-videos__viewport">' +
          '<div class="kc-tour-videos__row">' +
            vids.map(function (v, i) {
              return '<figure class="kc-tour-videos__item" data-idx="' + i + '" tabindex="0" role="button" style="animation-delay:' + (i * 45) + 'ms">' +
                       '<img src="' + spEsc(v.thumb) + '" alt="" loading="lazy">' +
                       '<span class="kc-tour-videos__play" aria-hidden="true"></span>' +
                       (v.title ? '<figcaption>' + spEsc(v.title) + '</figcaption>' : '') +
                     '</figure>';
            }).join('') +
          '</div>' +
          '<button class="kc-tour-videos__arrow kc-tour-videos__arrow--prev" type="button" aria-label="Scroll back" hidden>' + stripArrowSvg + '</button>' +
          '<button class="kc-tour-videos__arrow kc-tour-videos__arrow--next" type="button" aria-label="Scroll for more videos" hidden>' + stripArrowSvg + '</button>' +
        '</div>';
      vstrip.hidden = false;
      videoArrowUpdate = setupStripArrow(vstrip, '.kc-tour-videos__row', '.kc-tour-videos__arrow--prev', '.kc-tour-videos__arrow--next');
    }

    // Video playback uses the shared KCMediaLightbox (defined at the top of this
    // file). The heavy media is only injected when it opens, so browsing the news
    // page stays light. captionType:false keeps the news "Title · Category" caption.
    function openFromVideoFigure(fig) {
      if (!fig || !currentVideoYear) return;
      var items = (videosByYear[currentVideoYear] || []).map(function (v) {
        return { kind: 'v', label: v.title, src: v.src, ytid: v.ytid, thumb: v.thumb, cat: v.cat };
      });
      window.KCMediaLightbox.open(items, parseInt(fig.getAttribute('data-idx'), 10) || 0, { captionType: false });
    }
    vstrip.addEventListener('click', function (e) {
      openFromVideoFigure(e.target.closest && e.target.closest('.kc-tour-videos__item'));
    });
    vstrip.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var fig = e.target.closest && e.target.closest('.kc-tour-videos__item');
      if (fig) { e.preventDefault(); openFromVideoFigure(fig); }
    });

    var range = wrap.querySelector('.kc-year-slider__range');
    var labelEl = wrap.querySelector('.kc-year-slider__label');
    var ticksWrap = wrap.querySelector('.kc-year-slider__ticks');
    var ticks = Array.prototype.slice.call(wrap.querySelectorAll('.kc-year-slider__tick'));

    // Keep the active year centered in the scroll strip so the chips never run off
    // the screen and always track the slider. (No-op when everything already fits.)
    function centerTick(t) {
      if (!t || !ticksWrap) return;
      var c = ticksWrap.getBoundingClientRect();
      var r = t.getBoundingClientRect();
      var delta = (r.left + r.width / 2) - (c.left + c.width / 2);
      ticksWrap.scrollLeft += delta;
    }
    var settleTimer = null;
    var seq = 0; // request sequence; cancels stale fetches/animations while scrubbing
    var lastIndex = 0; // last year segment the (continuous) thumb was in

    function allManaged() {
      var arr = initialCards.slice();
      Object.keys(yearSets).forEach(function (y) { arr = arr.concat(yearSets[y]); });
      return arr;
    }

    // Masonry tiers for a set of N cards: big hero -> medium secondary -> small tertiary.
    function spanFor(idx, count) {
      if (count <= 1) return { col: 6, scale: 1, h: true };
      if (count === 2) return { col: 3, scale: 0.85, h: false };
      if (count === 3) return idx === 0 ? { col: 6, scale: 1, h: true } : { col: 3, scale: 0.85, h: false };
      if (count === 4) return idx === 0 ? { col: 6, scale: 1, h: true } : { col: 2, scale: 0.7, h: false };
      if (idx === 0) return { col: 6, scale: 1, h: true };    // hero
      if (idx <= 2) return { col: 3, scale: 0.85, h: false };  // secondary row
      return { col: 2, scale: 0.62, h: false };                // tertiary
    }

    function applyLayout(visible, isAll) {
      visible.forEach(function (el, i) {
        if (isAll) {
          el.style.removeProperty('--col-span');         // restore the original Liquid spans
          el.style.removeProperty('--blog-post-card-scale');
          el.classList.toggle('blog-post-item--horizontal', !!el.__origHoriz);
        } else {
          var s = spanFor(i, visible.length);
          el.style.setProperty('--col-span', s.col);
          el.style.setProperty('--blog-post-card-scale', s.scale);
          el.classList.toggle('blog-post-item--horizontal', s.h);
        }
      });
    }

    function clearTileStyles(el) {
      el.style.transition = '';
      el.style.opacity = '';
      el.style.transform = '';
    }

    // Pull a year's articles on demand from its tagged URL, import the cards, cache them.
    function fetchYear(stop) {
      if (yearSets[stop.year]) return Promise.resolve(yearSets[stop.year]);
      if (fetching[stop.year]) return fetching[stop.year];
      var p = fetch(stop.url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var imported = [];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var srcGrid = doc.querySelector('.blog-posts-container');
            if (srcGrid) {
              Array.prototype.forEach.call(srcGrid.querySelectorAll('.blog-post-item'), function (c) {
                var el = document.importNode(c, true);
                el.classList.add('kc-blog-hidden');
                el.setAttribute('data-year', stop.year);
                el.__origHoriz = false;
                grid.appendChild(el);
                imported.push(el);
              });
            }
          }
          yearSets[stop.year] = imported;
          return imported;
        })
        .catch(function () { yearSets[stop.year] = []; return []; });
      fetching[stop.year] = p;
      return p;
    }

    function targetFor(stop) {
      return stop.year === 'all' ? Promise.resolve(initialCards) : fetchYear(stop);
    }

    function animateTo(visible, isAll, my) {
      var managed = allManaged();
      var leaving = managed.filter(function (c) {
        return !c.classList.contains('kc-blog-hidden') && visible.indexOf(c) === -1;
      });

      if (reduceMotion) {
        managed.forEach(function (c) { c.classList.toggle('kc-blog-hidden', visible.indexOf(c) === -1); clearTileStyles(c); });
        applyLayout(visible, isAll);
        return;
      }

      // Phase 1 — stagger the current cards out.
      leaving.forEach(function (el, i) {
        el.style.transition = 'opacity 0.28s ease ' + (i * 18) + 'ms, transform 0.28s ease ' + (i * 18) + 'ms';
        el.style.opacity = '0';
        el.style.transform = 'translateY(10px) scale(0.94)';
      });
      var outTime = leaving.length ? Math.min(leaving.length * 18 + 220, 300) : 0;

      setTimeout(function () {
        if (my !== seq) return; // a newer selection superseded this one

        // Hide everyone not in the new set, then lay the new set out.
        managed.forEach(function (c) {
          if (visible.indexOf(c) === -1) { c.classList.add('kc-blog-hidden'); clearTileStyles(c); }
        });
        applyLayout(visible, isAll);

        // Phase 2 — reveal the new set, staggered in.
        visible.forEach(function (el) {
          el.classList.remove('kc-blog-hidden');
          el.style.transition = 'none';
          el.style.opacity = '0';
          el.style.transform = 'translateY(16px) scale(0.96)';
        });
        void grid.offsetWidth; // force reflow so the start state sticks
        visible.forEach(function (el, i) {
          el.style.transition = 'opacity 0.5s ease ' + (i * 30) + 'ms, transform 0.55s cubic-bezier(0.2,0.8,0.2,1) ' + (i * 30) + 'ms';
          el.style.opacity = '';
          el.style.transform = '';
        });
        // Tidy inline transition styles once the animation is done.
        setTimeout(function () {
          if (my === seq) visible.forEach(function (el) { el.style.transition = ''; });
        }, visible.length * 30 + 600);
      }, outTime);
    }

    function show(stopIndex) {
      var stop = stops[stopIndex];
      renderStrip(stop.year); // surface that year's tour/event photos
      renderVideoStrip(stop.year); // ...and that year's videos
      var my = ++seq;
      grid.classList.add('kc-blog-loading');
      targetFor(stop).then(function (target) {
        if (my !== seq) return;            // a newer selection superseded this one
        grid.classList.remove('kc-blog-loading');
        animateTo(target, stop.year === 'all', my);
      });
    }

    function setReadout(i) {
      labelEl.textContent = stops[i].year === 'all' ? 'All Years' : stops[i].label;
      ticks.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      centerTick(ticks[i]);
    }

    function setStop(i, animate) {
      i = Math.max(0, Math.min(stops.length - 1, i));
      range.value = i;
      lastIndex = i;
      setReadout(i);
      if (animate) show(i);
    }

    function clampIndex(v) {
      return Math.max(0, Math.min(stops.length - 1, Math.round(parseFloat(v) || 0)));
    }

    // Silky-smooth drag: the thumb glides continuously (step="any"). The active
    // year + content only change the moment the thumb crosses into a new year's
    // segment — no snapping, no choppy year-by-year jumps while scrubbing.
    range.addEventListener('input', function () {
      var i = clampIndex(range.value);
      if (i === lastIndex) return; // still inside the same year -> keep gliding
      lastIndex = i;
      setReadout(i); // highlight the year just crossed into
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () { show(i); }, 120);
    });
    range.addEventListener('change', function () {
      var i = clampIndex(range.value);
      lastIndex = i;
      setReadout(i);
      clearTimeout(settleTimer);
      show(i);
    });
    ticks.forEach(function (t, ti) {
      t.addEventListener('click', function () { setStop(ti, true); });
    });

    setStop(0, false); // start on "All" = the current full grid
  });
})();

/*-------- Tour page: spotlight + countdown + upcoming/past from tour_date metaobjects --------*/
(function () {
  var root = document.querySelector('[data-kc-tour-page]');
  if (!root) return;
  var mount = root.querySelector('[data-kc-tour-mount]');
  var dataEl = root.querySelector('[data-kc-tour-data]');
  if (!mount || !dataEl) return;

  var events;
  try { events = JSON.parse(dataEl.textContent || '[]'); } catch (e) { events = []; }
  events = (events || []).filter(function (e) { return e && e.ts; }).map(function (e) {
    e.ts = parseInt(e.ts, 10);
    return e;
  });
  events.sort(function (a, b) { return a.ts - b.ts; });

  var emptyEl = root.querySelector('[data-kc-tour-empty]');
  if (!events.length) { if (emptyEl) emptyEl.hidden = false; return; }

  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fmtDate(ts) {
    var d = new Date(ts * 1000);
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }
  function cityLine(e) {
    return [e.city, e.region].filter(Boolean).join(', ');
  }
  function isCancelled(e) { return (e.sync_status || '').toLowerCase() === 'cancelled'; }

  function ticketCta(e, cls) {
    if (isCancelled(e)) return '<span class="kc-tp-btn ' + cls + '" aria-disabled="true">Cancelled</span>';
    if (e.sold_out) return '<span class="kc-tp-btn ' + cls + '" aria-disabled="true">Sold Out</span>';
    if (e.ticket_url) return '<a class="kc-tp-btn ' + cls + '" href="' + esc(e.ticket_url) + '" target="_blank" rel="noopener">Buy Tickets</a>';
    return '<span class="kc-tp-btn ' + cls + '" aria-disabled="true">On Sale Soon</span>';
  }

  var now = Date.now() / 1000;
  var upcoming = events.filter(function (e) { return e.ts >= now; });
  var past = events.filter(function (e) { return e.ts < now; }).reverse(); // most recent first

  // Spotlight = the featured upcoming show, else the soonest upcoming.
  var spotlight = null;
  for (var i = 0; i < upcoming.length; i++) { if (upcoming[i].featured) { spotlight = upcoming[i]; break; } }
  if (!spotlight && upcoming.length) spotlight = upcoming[0];

  var html = '';

  // ---- Spotlight ----
  if (spotlight) {
    var badge = isCancelled(spotlight)
      ? '<span class="kc-tp-badge kc-tp-badge--cancelled">Cancelled</span>'
      : (spotlight.sold_out ? '<span class="kc-tp-badge kc-tp-badge--soldout">Sold Out</span>' : '');
    html += '<div class="kc-tp-spotlight">' +
      '<div class="kc-tp-spotlight__info">' +
        '<div class="kc-tp-spotlight__eyebrow">Next Show</div>' +
        '<div class="kc-tp-spotlight__date">' + esc(fmtDate(spotlight.ts)) + badge + '</div>' +
        '<div class="kc-tp-spotlight__venue">' + esc(spotlight.venue) + '</div>' +
        '<div class="kc-tp-spotlight__city">' + esc(cityLine(spotlight)) + '</div>' +
        (spotlight.hype ? '<p class="kc-tp-spotlight__hype">' + esc(spotlight.hype) + '</p>' : '') +
        '<div class="kc-tp-spotlight__cta">' + ticketCta(spotlight, 'kc-tp-btn') + '</div>' +
      '</div>' +
      '<div class="kc-tp-spotlight__aside">' +
        '<div>' +
          '<div class="kc-tp-countdown-label">Doors Open In</div>' +
          '<div class="kc-countdown" data-kc-tp-countdown data-target="' + spotlight.ts + '" aria-live="polite">' +
            '<span class="kc-cd-unit"><b data-d>--</b><i>Days</i></span>' +
            '<span class="kc-cd-unit"><b data-h>--</b><i>Hrs</i></span>' +
            '<span class="kc-cd-unit"><b data-m>--</b><i>Min</i></span>' +
            '<span class="kc-cd-unit"><b data-s>--</b><i>Sec</i></span>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // ---- Upcoming list (excluding the spotlight) ----
  var rest = upcoming.filter(function (e) { return e !== spotlight; });
  if (rest.length) {
    html += '<h2 class="kc-tp-section-title">Upcoming Shows</h2><ul class="kc-tp-list" role="list">';
    rest.forEach(function (e) {
      var b = isCancelled(e)
        ? '<span class="kc-tp-badge kc-tp-badge--cancelled">Cancelled</span>'
        : (e.sold_out ? '<span class="kc-tp-badge kc-tp-badge--soldout">Sold Out</span>' : '');
      html += '<li class="kc-tp-row">' +
        '<div class="kc-tp-row__main">' +
          '<span class="kc-tp-row__date">' + esc(fmtDate(e.ts)) + b + '</span>' +
          '<span class="kc-tp-row__venue">' + esc(e.venue) + '</span>' +
          '<span class="kc-tp-row__city">' + esc(cityLine(e)) + '</span>' +
        '</div>' +
        ticketCta(e, 'kc-tp-btn kc-tp-btn--ghost') +
      '</li>';
    });
    html += '</ul>';
  }

  // (Past Tours is built from the photo/video collections below, async.)

  mount.innerHTML = html;

  // ---- Countdown tick (reuses the .kc-countdown markup/styles) ----
  var cd = mount.querySelector('[data-kc-tp-countdown]');
  if (cd) {
    var target = parseInt(cd.getAttribute('data-target'), 10);
    var set = function (sel, v) { var el = cd.querySelector(sel); if (el) el.textContent = v; };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = target - Date.now() / 1000;
      if (diff <= 0) {
        set('[data-d]', '0'); set('[data-h]', '00'); set('[data-m]', '00'); set('[data-s]', '00');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      set('[data-d]', d); set('[data-h]', pad(h)); set('[data-m]', pad(m)); set('[data-s]', pad(s));
    };
    tick();
    var timer = setInterval(tick, 1000);
  }

  // ---- Past Tours: collection cards (cover + tour + year); click to browse in the lightbox ----
  if (window.KCMediaLightbox) {
    var FEED = 'https://kc-cloudflare-feed.sparkart.workers.dev';
    var fullSizeUrl = function (img) {
      return String(img || '').replace(/\/image\/fetch\/[^/]+\//, '/image/fetch/c_limit,w_1600,f_auto,q_auto/');
    };

    Promise.all([
      fetch(FEED + '/photos.json', { mode: 'cors' }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }),
      fetch(FEED + '/videos.json', { mode: 'cors' }).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; })
    ]).then(function (res) {
      var allPhotos = (res[0] && res[0].photos) || [];
      var allVideos = (res[1] && res[1].videos) || [];
      if (!allPhotos.length) return;

      // Group photos into tour collections by category; newest year first.
      var order = [], byCat = {};
      allPhotos.forEach(function (p) {
        var cat = p.cat || 'Photos';
        if (!byCat[cat]) { byCat[cat] = { name: cat, year: p.year, cover: p.img, photos: [] }; order.push(cat); }
        byCat[cat].photos.push(p);
        if (p.year && (!byCat[cat].year || p.year > byCat[cat].year)) byCat[cat].year = p.year;
      });
      var cols = order.map(function (c) { return byCat[c]; })
        .sort(function (a, b) { return (b.year || 0) - (a.year || 0); });
      if (!cols.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'kc-tp-pasttours';
      wrap.innerHTML = '<h2 class="kc-tp-section-title">Past Tours</h2>' +
        '<ul class="kc-tp-collections" role="list">' +
          cols.map(function (col, ci) {
            return '<li class="kc-tp-collection">' +
              '<button class="kc-tp-collection__btn" type="button" data-col="' + ci + '" aria-label="' + esc(col.name) + '">' +
                '<span class="kc-tp-collection__media"><img src="' + esc(col.cover) + '" alt="" loading="lazy"></span>' +
                '<span class="kc-tp-collection__meta">' +
                  '<span class="kc-tp-collection__name">' + esc(col.name) + '</span>' +
                  (col.year ? '<span class="kc-tp-collection__year">' + esc(col.year) + '</span>' : '') +
                  '<span class="kc-tp-collection__count">' + col.photos.length + ' photos</span>' +
                '</span>' +
              '</button></li>';
          }).join('') +
        '</ul>';
      mount.appendChild(wrap);

      // Click a collection -> open its photos + that year's videos in the tabbed lightbox.
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.kc-tp-collection__btn');
        if (!btn) return;
        var col = cols[parseInt(btn.getAttribute('data-col'), 10)];
        if (!col) return;
        var items = col.photos.map(function (p) {
          return { kind: 'p', label: p.caption || p.cat || '', src: fullSizeUrl(p.img), thumb: p.img };
        });
        allVideos.filter(function (v) { return String(v.year) === String(col.year); }).forEach(function (v) {
          items.push({ kind: 'v', label: v.title, src: v.src, ytid: v.ytid, thumb: v.thumb, cat: v.cat });
        });
        window.KCMediaLightbox.open(items, 0, {
          title: col.name + (col.year ? ' · ' + col.year : ''),
          tabs: true,
          captionType: false
        });
      });
    });
  }
})();

/*-------- Homepage tour: next-N upcoming cards (+ optional countdown) from tour_date metaobjects --------*/
(function () {
  var root = document.querySelector('[data-kc-home-tour]');
  if (!root) return;
  var mount = root.querySelector('[data-kc-home-tour-mount]');
  var dataEl = root.querySelector('[data-kc-home-tour-data]');
  if (!mount || !dataEl) return; // fallback Liquid render is active

  var events;
  try { events = JSON.parse(dataEl.textContent || '[]'); } catch (e) { events = []; }
  events = (events || []).filter(function (e) { return e && e.ts; }).map(function (e) {
    e.ts = parseInt(e.ts, 10);
    return e;
  });
  events.sort(function (a, b) { return a.ts - b.ts; });

  var max = parseInt(mount.getAttribute('data-max'), 10) || 6;
  var showAll = mount.getAttribute('data-show-all') === 'true';
  var buttonLabel = mount.getAttribute('data-button-label') || 'BUY TICKETS';
  var wantCountdown = mount.getAttribute('data-countdown') === 'true';

  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fmtDate(ts) {
    var d = new Date(ts * 1000);
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }
  function cityLine(e) {
    return [e.city, e.region].filter(Boolean).join(', ');
  }
  function isCancelled(e) { return (e.sync_status || '').toLowerCase() === 'cancelled'; }
  function statusPill(e) {
    if (isCancelled(e)) return '<span class="kc-tour__ticket kc-tour__ticket--disabled">Cancelled</span>';
    if (e.sold_out) return '<span class="kc-tour__ticket kc-tour__ticket--disabled">Sold Out</span>';
    return '';
  }

  function ticket(e) {
    if (isCancelled(e)) return '<span class="kc-tour__ticket kc-tour__ticket--disabled">Cancelled</span>';
    if (e.sold_out) return '<span class="kc-tour__ticket kc-tour__ticket--disabled">Sold Out</span>';
    if (e.ticket_url) {
      return '<a class="kc-tour__ticket" href="' + esc(e.ticket_url) + '" target="_blank" rel="noopener">' + esc(buttonLabel) + '</a>';
    }
    return '<span class="kc-tour__ticket kc-tour__ticket--disabled">' + esc(buttonLabel) + '</span>';
  }

  var now = Date.now() / 1000;
  var upcoming = events.filter(function (e) { return e.ts >= now; });
  if (!upcoming.length) return; // leave mount empty; section header still shows

  // Optional spotlight = the soonest upcoming show, with a live countdown.
  var spotlightEl = root.querySelector('[data-kc-home-tour-spotlight]');
  var spotlight = (wantCountdown && spotlightEl) ? upcoming[0] : null;

  // List shows the remaining upcoming shows. When "show all" is on, list
  // every date; otherwise cap so the on-screen total (spotlight + list)
  // never exceeds max.
  var listStart = spotlight ? 1 : 0;
  var listEnd = showAll ? upcoming.length : max;
  var listed = upcoming.slice(listStart, listEnd);
  var shownCount = listStart + listed.length;

  if (spotlight) {
    spotlightEl.className = 'kc-tour__card kc-tour__card--spotlight';
    spotlightEl.innerHTML =
      '<div class="kc-tour__spotlight-head">' +
        '<div class="kc-tour__spotlight-eyebrow">Next Show</div>' +
        '<div class="kc-tour__spotlight-date">' + esc(fmtDate(spotlight.ts)) + ' ' + statusPill(spotlight) + '</div>' +
        '<div class="kc-tour__spotlight-where">' + esc(spotlight.venue || '') +
          (cityLine(spotlight) ? ' &middot; ' + esc(cityLine(spotlight)) : '') + '</div>' +
      '</div>' +
      '<div class="kc-tour__spotlight-cd">' +
        '<div class="kc-countdown" data-target="' + spotlight.ts + '" aria-live="polite">' +
          '<span class="kc-cd-unit"><b data-d>--</b><i>Days</i></span>' +
          '<span class="kc-cd-unit"><b data-h>--</b><i>Hrs</i></span>' +
          '<span class="kc-cd-unit"><b data-m>--</b><i>Min</i></span>' +
          '<span class="kc-cd-unit"><b data-s>--</b><i>Sec</i></span>' +
        '</div>' +
        ticket(spotlight) +
      '</div>';
    spotlightEl.hidden = false;

    var cd = spotlightEl.querySelector('.kc-countdown');
    var target = parseInt(cd.getAttribute('data-target'), 10);
    var setv = function (sel, v) { var el = cd.querySelector(sel); if (el) el.textContent = v; };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = target - Date.now() / 1000;
      if (diff <= 0) {
        setv('[data-d]', '0'); setv('[data-h]', '00'); setv('[data-m]', '00'); setv('[data-s]', '00');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      setv('[data-d]', d); setv('[data-h]', pad(h)); setv('[data-m]', pad(m)); setv('[data-s]', pad(s));
    };
    tick();
    var timer = setInterval(tick, 1000);
  }

  var html = '';
  listed.forEach(function (e) {
    html += '<li class="kc-tour__card">' +
      '<div class="kc-tour__show">' +
        '<div class="kc-tour__date">' + esc(fmtDate(e.ts)) + '</div>' +
        (e.venue ? '<div class="kc-tour__venue">' + esc(e.venue) + '</div>' : '') +
        (cityLine(e) ? '<div class="kc-tour__city">' + esc(cityLine(e)) + '</div>' : '') +
      '</div>' +
      ticket(e) +
    '</li>';
  });
  mount.innerHTML = html;

  // Desktop pointer tilt on the NEXT SHOW spotlight card only — it's the
  // headline, so it gets the album-cover-style hover (custom.js:1239) while the
  // list below stays calm. Pointer devices only, disabled for reduced-motion.
  if (spotlight && spotlightEl && window.matchMedia &&
      window.matchMedia('(hover: hover)').matches &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    spotlightEl.addEventListener('mousemove', function (e) {
      var r = spotlightEl.getBoundingClientRect();
      var px = ((e.clientX - r.left) / r.width - 0.5) * 2;
      var py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      spotlightEl.style.transform = 'rotateY(' + (px * 5).toFixed(1) + 'deg) rotateX(' + (-py * 6).toFixed(1) + 'deg) scale(1.025)';
    });
    spotlightEl.addEventListener('mouseleave', function () { spotlightEl.style.transform = ''; });
  }

  // "See all shows" CTA when there are more upcoming shows than we display,
  // unless the editor's header "view all" button is already shown.
  var moreEl = root.querySelector('[data-kc-home-tour-more]');
  if (moreEl && upcoming.length > shownCount && !root.querySelector('.kc-tour__header .kc-tour__view-all')) {
    var href = moreEl.getAttribute('data-href') || '/pages/tour';
    var label = moreEl.getAttribute('data-label') || 'SEE ALL DATES';
    var nt = moreEl.getAttribute('data-new-tab') === 'true' ? ' target="_blank" rel="noopener"' : '';
    moreEl.innerHTML = '<a class="kc-tour__pill" href="' + esc(href) + '"' + nt + '>' + esc(label) + '</a>';
    moreEl.hidden = false;
  }
})();

/*-------- Tour Dates section: spotlight + countdown + upcoming from tour_date metaobjects --------*/
(function () {
  var root = document.querySelector('[data-kc-tour-dates]');
  if (!root) return;
  var mount = root.querySelector('[data-kc-tour-dates-mount]');
  var dataEl = root.querySelector('[data-kc-tour-dates-data]');
  if (!mount || !dataEl) return;

  var events;
  try { events = JSON.parse(dataEl.textContent || '[]'); } catch (e) { events = []; }
  events = (events || []).filter(function (e) { return e && e.ts; }).map(function (e) {
    e.ts = parseInt(e.ts, 10);
    return e;
  });
  events.sort(function (a, b) { return a.ts - b.ts; });

  var emptyEl = root.querySelector('[data-kc-tour-dates-empty]');
  if (!events.length) { if (emptyEl) emptyEl.hidden = false; return; }

  var MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function fmtDate(ts) {
    var d = new Date(ts * 1000);
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }
  function cityLine(e) {
    return [e.city, e.region].filter(Boolean).join(', ');
  }
  function isCancelled(e) { return (e.sync_status || '').toLowerCase() === 'cancelled'; }

  function ticketCta(e, cls) {
    if (isCancelled(e)) return '<span class="kc-tp-btn ' + cls + '" aria-disabled="true">Cancelled</span>';
    if (e.sold_out) return '<span class="kc-tp-btn ' + cls + '" aria-disabled="true">Sold Out</span>';
    if (e.ticket_url) return '<a class="kc-tp-btn ' + cls + '" href="' + esc(e.ticket_url) + '" target="_blank" rel="noopener">Buy Tickets</a>';
    return '<span class="kc-tp-btn ' + cls + '" aria-disabled="true">On Sale Soon</span>';
  }

  var now = Date.now() / 1000;
  var upcoming = events.filter(function (e) { return e.ts >= now; });

  // Spotlight = the featured upcoming show, else the soonest upcoming.
  var spotlight = null;
  for (var i = 0; i < upcoming.length; i++) { if (upcoming[i].featured) { spotlight = upcoming[i]; break; } }
  if (!spotlight && upcoming.length) spotlight = upcoming[0];

  var html = '';

  // ---- Spotlight ----
  if (spotlight) {
    var badge = isCancelled(spotlight)
      ? '<span class="kc-tp-badge kc-tp-badge--cancelled">Cancelled</span>'
      : (spotlight.sold_out ? '<span class="kc-tp-badge kc-tp-badge--soldout">Sold Out</span>' : '');
    html += '<div class="kc-tp-spotlight">' +
      '<div class="kc-tp-spotlight__info">' +
        '<div class="kc-tp-spotlight__eyebrow">Next Show</div>' +
        '<div class="kc-tp-spotlight__date">' + esc(fmtDate(spotlight.ts)) + badge + '</div>' +
        '<div class="kc-tp-spotlight__venue">' + esc(spotlight.venue) + '</div>' +
        '<div class="kc-tp-spotlight__city">' + esc(cityLine(spotlight)) + '</div>' +
        (spotlight.hype ? '<p class="kc-tp-spotlight__hype">' + esc(spotlight.hype) + '</p>' : '') +
        '<div class="kc-tp-spotlight__cta">' + ticketCta(spotlight, 'kc-tp-btn') + '</div>' +
      '</div>' +
      '<div class="kc-tp-spotlight__aside">' +
        '<div>' +
          '<div class="kc-tp-countdown-label">Doors Open In</div>' +
          '<div class="kc-countdown" data-kc-tp-countdown data-target="' + spotlight.ts + '" aria-live="polite">' +
            '<span class="kc-cd-unit"><b data-d>--</b><i>Days</i></span>' +
            '<span class="kc-cd-unit"><b data-h>--</b><i>Hrs</i></span>' +
            '<span class="kc-cd-unit"><b data-m>--</b><i>Min</i></span>' +
            '<span class="kc-cd-unit"><b data-s>--</b><i>Sec</i></span>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // ---- Upcoming list (excluding the spotlight) ----
  var rest = upcoming.filter(function (e) { return e !== spotlight; });
  if (rest.length) {
    html += '<h2 class="kc-tp-section-title">Upcoming Shows</h2><ul class="kc-tp-list" role="list">';
    rest.forEach(function (e) {
      var b = isCancelled(e)
        ? '<span class="kc-tp-badge kc-tp-badge--cancelled">Cancelled</span>'
        : (e.sold_out ? '<span class="kc-tp-badge kc-tp-badge--soldout">Sold Out</span>' : '');
      html += '<li class="kc-tp-row">' +
        '<div class="kc-tp-row__main">' +
          '<span class="kc-tp-row__date">' + esc(fmtDate(e.ts)) + b + '</span>' +
          '<span class="kc-tp-row__venue">' + esc(e.venue) + '</span>' +
          '<span class="kc-tp-row__city">' + esc(cityLine(e)) + '</span>' +
        '</div>' +
        ticketCta(e, 'kc-tp-btn kc-tp-btn--ghost') +
      '</li>';
    });
    html += '</ul>';
  }

  mount.innerHTML = html;

  // ---- Countdown tick (reuses the .kc-countdown markup/styles) ----
  var cd = mount.querySelector('[data-kc-tp-countdown]');
  if (cd) {
    var target = parseInt(cd.getAttribute('data-target'), 10);
    var set = function (sel, v) { var el = cd.querySelector(sel); if (el) el.textContent = v; };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = target - Date.now() / 1000;
      if (diff <= 0) {
        set('[data-d]', '0'); set('[data-h]', '00'); set('[data-m]', '00'); set('[data-s]', '00');
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      set('[data-d]', d); set('[data-h]', pad(h)); set('[data-m]', pad(m)); set('[data-s]', pad(s));
    };
    tick();
    var timer = setInterval(tick, 1000);
  }
})();

/*-------- Past Tours section: metaobject-driven tour cards + shared lightbox --------*/
(function () {
  var root = document.querySelector('[data-kc-past-tours]');
  if (!root || !window.KCMediaLightbox) return;
  var row = root.querySelector('.kc-tp-collections');
  if (!row) return;

  // Wire prev/next arrows like the /collections carousel: prev hides at the start,
  // next hides at the end, both hide when the row doesn't overflow (CSS only paints
  // them in carousel layout).
  var prevArrow = root.querySelector('.kc-past-tours__arrow--prev');
  var nextArrow = root.querySelector('.kc-past-tours__arrow--next');
  var updateArrow = function () {
    var overflows = row.scrollWidth - row.clientWidth > 4;
    var atStart = row.scrollLeft <= 4;
    var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    if (prevArrow) prevArrow.hidden = !overflows || atStart;
    if (nextArrow) nextArrow.hidden = !overflows || atEnd;
  };
  if (prevArrow) prevArrow.addEventListener('click', function () {
    row.scrollBy({ left: -Math.round(row.clientWidth * 0.85), behavior: 'smooth' });
  });
  if (nextArrow) nextArrow.addEventListener('click', function () {
    row.scrollBy({ left: Math.round(row.clientWidth * 0.85), behavior: 'smooth' });
  });
  row.addEventListener('scroll', updateArrow, { passive: true });
  window.addEventListener('resize', updateArrow);
  updateArrow();

  // Click a tour -> open all its photos + videos in the tabbed shared lightbox.
  // Each card carries its media list as inline JSON (server-rendered from the
  // tour's related photo/video categories).
  root.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kc-tp-collection__btn');
    if (!btn) return;
    var li = btn.closest('.kc-tp-collection');
    var data = li && li.querySelector('script[data-kc-tour-media]');
    if (!data) return;
    var items;
    try { items = JSON.parse(data.textContent); } catch (err) { return; }
    if (!items || !items.length) return;
    window.KCMediaLightbox.open(items, 0, {
      title: btn.getAttribute('data-kc-title') || '',
      tabs: true,
      captionType: false
    });
  });
})();

/*-------- MENUS: external links open in a new tab, internal stay in tab --------*/
(function () {
  // Header (.menu-list, .header-menu, drawer) + footer menus. Scoped to nav/menu
  // containers so we don't touch in-page content links. Hostname is read at
  // runtime, so this keeps working when the store moves to its custom domain.
  var MENU_SCOPE = '.menu-list, .header-menu, .menu-drawer, header-drawer, .footer, footer';

  function markExternal(scope) {
    var anchors = scope.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var href = a.getAttribute('href') || '';
      // Skip non-navigational + already-handled links.
      if (/^(mailto:|tel:|sms:|#|javascript:)/i.test(href)) continue;
      if (a.protocol !== 'http:' && a.protocol !== 'https:') continue;
      if (!a.hostname || a.hostname === window.location.hostname) continue;

      a.target = '_blank';
      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      a.setAttribute('rel', rel.join(' '));
    }
  }

  function run() {
    var scopes = document.querySelectorAll(MENU_SCOPE);
    for (var i = 0; i < scopes.length; i++) markExternal(scopes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // The header/menus hydrate client-side and the mega menu/drawer can re-render,
  // which would drop our attributes. Re-apply on menu subtree changes (debounced).
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      run();
    });
  });
  function observe() {
    var roots = document.querySelectorAll(MENU_SCOPE);
    for (var i = 0; i < roots.length; i++) {
      observer.observe(roots[i], { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();


/*-------- Carousel drag-to-scroll with momentum (touch + mouse) --------------
   Native touch-scroll is unreliable on these KC tracks (arrows work, a finger
   swipe doesn't), so we drive the horizontal scroll in JS: 1:1 while dragging,
   then a short momentum glide on release. The proximity scroll-snap (custom.css)
   gently resolves to a card. Tracks set touch-action: pan-y so vertical page
   scroll stays native and the browser hands horizontal moves to us. A real drag
   suppresses the trailing click so a card doesn't open mid-swipe. Carousels
   render async, so a MutationObserver wires up tracks as they appear. */
(function () {
  var SELECTORS = [
    '.kc-past-tours--carousel .kc-tp-collections',
    '.kc-tour__merch-track',
    '.kc-album-detail__rail'
  ];

  function enable(el) {
    if (!el || el.__kcDrag) return;
    el.__kcDrag = true;
    var startX = 0, startY = 0, startLeft = 0, lastX = 0, lastT = 0;
    var vel = 0, dragging = false, dir = null, moved = 0, raf = null;

    function down(x, y) {
      dragging = true; dir = null; moved = 0; vel = 0;
      startX = lastX = x; startY = y; startLeft = el.scrollLeft; lastT = Date.now();
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    }
    function move(x, y, e) {
      if (!dragging) return;
      var dx = x - startX, dy = y - startY;
      if (dir === null) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      }
      if (dir !== 'h') { dragging = false; return; }
      if (e && e.cancelable) e.preventDefault();
      var now = Date.now(), dt = (now - lastT) || 16;
      vel = (x - lastX) / dt;
      lastX = x; lastT = now;
      moved = Math.abs(dx);
      el.scrollLeft = startLeft - dx;
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      var v = vel * 16; // px per frame
      if (Math.abs(v) < 1) return;
      (function glide() {
        if (Math.abs(v) < 0.4) { raf = null; return; }
        el.scrollLeft -= v;
        v *= 0.92;
        raf = requestAnimationFrame(glide);
      })();
    }

    el.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) down(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    el.addEventListener('touchmove', function (e) {
      if (e.touches.length === 1) move(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });
    el.addEventListener('touchend', up);
    el.addEventListener('touchcancel', up);

    el.addEventListener('mousedown', function (e) {
      if (e.button === 0) { down(e.clientX, e.clientY); e.preventDefault(); }
    });
    window.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX, e.clientY, e); });
    window.addEventListener('mouseup', up);

    el.addEventListener('click', function (e) {
      if (moved > 8) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);
  }

  function scan() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var n = document.querySelectorAll(SELECTORS[i]);
      for (var j = 0; j < n.length; j++) enable(n[j]);
    }
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  setTimeout(scan, 1000);
  setTimeout(scan, 2500);
  try {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].addedNodes && m[i].addedNodes.length) { scan(); break; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

/*-------- Resource-list carousels: hide arrows when all slides fit --------
   Horizon's `auto-hide-controls` only hides the dots/controls slot, not the
   <slideshow-arrows>. Resource-list carousels have arrows but no dots, so one
   with too few items to scroll (e.g. a 3-product featured collection in a 4-up
   layout) kept showing a next arrow on hover. Toggle .kc-carousel-fits on the
   slideshow-component when its scroller does not overflow; CSS hides the arrows. */
(function () {
  var carousels = document.querySelectorAll('slideshow-component.resource-list__carousel');
  if (!carousels.length) return;
  function sync(sc) {
    var scroller = sc.querySelector('slideshow-slides');
    if (!scroller) return;
    // +1px tolerance for sub-pixel rounding.
    var fits = scroller.scrollWidth <= scroller.clientWidth + 1;
    sc.classList.toggle('kc-carousel-fits', fits);
  }
  [].forEach.call(carousels, function (sc) {
    var scroller = sc.querySelector('slideshow-slides');
    if (!scroller) return;
    sync(sc);
    if (window.ResizeObserver) {
      new ResizeObserver(function () { sync(sc); }).observe(scroller);
    }
  });
  window.addEventListener('load', function () { [].forEach.call(carousels, sync); });
})();
